import React from 'react'

const Badge = props => (
  <svg
    height={props.height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 24.3"
  >
    <defs>
      <clipPath id="badge2_a">
        <circle cx="11.5" cy="11.5" r="8" fill="none" />
      </clipPath>
      <clipPath id="badge2_b">
        <path
          d="M6.6 13.2l-.4.3a.9.9 0 1 1 1 1.4l.4-.2a.9.9 0 1 0-1-1.5z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_c">
        <path
          d="M5.5 14l-.4.2a.9.9 0 1 1 1 1.5l.4-.3a.9.9 0 0 0-1-1.5z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_d">
        <path
          d="M3.3 15.6l-1.4.9.6-.3h.1a.1.1 0 0 1 0 .2l-.3.2v.1l.3-.1a.1.1 0 0 1 .1 0 .1.1 0 0 1 0 .1l-.8.6.7-.4a.1.1 0 0 1 .1 0v.2l-.3.1v.1c0 .1 0 0 .1 0L3 17a.1.1 0 0 1 .2 0 .1.1 0 0 1-.1.2l-1 .6.1.2 2-1.3a.8.8 0 0 0 .2-1 .8.8 0 0 0-1-.1z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_e">
        <path
          d="M9 11.6l-.5.3a.9.9 0 0 1 1.3.2.9.9 0 0 1-.3 1.2l.4-.2a.9.9 0 0 0-1-1.5z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_f">
        <path
          d="M7.8 12.3l-.4.3a.9.9 0 1 1 1 1.5l.4-.3a.9.9 0 0 0-1-1.5z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_g">
        <path
          d="M5.6 14l-1.4 1 .6-.3a.1.1 0 1 1 .1.1l-.4.2v.1h.1l.2-.1H5l-.1.1-.8.6h.1l.6-.3H5l-.2.2-.1.1h.1l.5-.3a.1.1 0 0 1 .2 0v.1l-1 .7v.2l2-1.2a.8.8 0 0 0 .2-1 .8.8 0 0 0-1-.2z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_h">
        <path
          d="M11.6 8.7l-.4.3a.9.9 0 0 1 1.2 1.3l.4-.3a.9.9 0 0 0 0-1.3.9.9 0 0 0-1.2 0z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_i">
        <path
          d="M10.6 9.6l-.4.3a.9.9 0 1 1 1.2 1.3l.4-.3a.9.9 0 0 0-1.2-1.3z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_j">
        <path
          d="M8.6 11.6l-1.2 1v.2l.6-.4h.1v.1l-.3.3v.1H8l.1-.2h.2a.1.1 0 0 1 0 .2l-.7.6v.1l.6-.5h.1v.2l-.2.2h.1l.5-.4a.1.1 0 0 1 .2 0 .1.1 0 0 1 0 .2l-1 .7.1.2 1.7-1.6a.7.7 0 1 0-1-1z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_k">
        <path
          d="M14.7 8.8h-.5a.9.9 0 0 1 0 1.7h.5a.9.9 0 1 0 0-1.7z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_l">
        <path
          d="M13.3 8.8h-.5a.9.9 0 1 1 0 1.8h.6a.9.9 0 0 0 .8-1 .9.9 0 0 0-.9-.8z"
          fill="none"
        />
      </clipPath>
      <clipPath id="badge2_m">
        <path
          d="M10.6 9l-1.7.2v.1h.6a.1.1 0 0 1 .2 0 .1.1 0 0 1-.2.2h-.4H9v.1h.3a.1.1 0 0 1 .1 0 .1.1 0 0 1 0 .2H8.2v.1h.8a.1.1 0 0 1 .1 0l-.1.2h-.3.7a.1.1 0 0 1 .1.1.1.1 0 0 1-.1.1H8.3v.3h2.3a.7.7 0 1 0 0-1.5z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g data-name="Warstwa 2">
      <circle cx="11.5" cy="11.5" r="8" fill="#00b4ff" />
      <path
        d="M11.4.5c.2 0 .6-.5.9-.5s.6.6.9.6.7-.4 1-.3.5.7.7.7.8-.2 1.1-.1.4.7.6.8.9 0 1 0 .3.8.6 1 .8 0 1 .2 0 .9.3 1 .8.2 1 .4 0 .8.1 1 .8.3 1 .6-.2.8 0 1 .7.4.8.7-.3.8-.3 1 .7.5.7.8-.4.7-.3 1 .5.6.5.9-.5.7-.5 1 .4.6.4 1-.6.5-.7.7.3.8.2 1-.7.5-.8.7.2.8.1 1-.8.4-.9.6 0 .9-.1 1-.8.3-1 .5 0 .8-.3 1-.8 0-1 .2-.2.8-.4 1-.9 0-1 0-.4.8-.7 1-.8-.3-1-.2-.5.7-.8.7-.7-.3-1-.2-.6.6-.8.6-.7-.5-1-.5-.7.6-1 .6-.6-.6-.9-.6-.7.4-1 .3-.5-.7-.7-.7-.8.2-1 .1-.5-.7-.7-.9-.8.2-1 0-.3-.7-.5-.9-.9 0-1-.2-.2-.8-.3-1-.9-.2-1-.4 0-.8-.2-1-.8-.3-.9-.5.1-.8 0-1-.7-.5-.8-.7.3-.8.2-1-.7-.6-.7-.8.4-.8.4-1-.6-.8-.6-1 .5-.7.5-1-.4-.7-.4-1 .7-.6.7-.8-.3-.8-.2-1 .7-.5.8-.7-.2-.8 0-1 .7-.4.8-.6 0-.9.1-1 .8-.2 1-.4.1-.9.3-1 .8 0 1-.2.2-.8.5-1 .8 0 1 0 .4-.8.6-1 .8.3 1 .2.5-.7.8-.8.7.4 1 .3.5-.6.8-.6.8.4 1 .4z"
        fill="#00b4ff"
      />
      <circle cx="11.5" cy="11.5" r="10.9" fill="#00b4ff" />
      <path
        d="M19.8 11.5a8.3 8.3 0 1 1-8.3-8.3 8.3 8.3 0 0 1 8.3 8.3zM7 3l.4-.2.3.5a1.5 1.5 0 0 1-.3.2.5.5 0 0 1-.4 0 .5.5 0 0 1-.3-.3.5.5 0 0 1 0-.4.5.5 0 0 1 .2-.3H7.2v.2a.5.5 0 0 0-.2 0 .2.2 0 0 0-.1.2.3.3 0 0 0 0 .2.3.3 0 0 0 .1.2.2.2 0 0 0 .2 0h.1V3h-.2zM8 2.8l.1.3-.2.1-.4-1h.3q.4-.2.5.1a.3.3 0 0 1 0 .3l.4.3-.3.1-.3-.3zm0-.2a.1.1 0 0 0 0-.2zM9.4 2.7l-.1-.2-.3.1v.2h-.3v-1h.4l.5.9zm-.2-.4L9 2V2v.4zM10.3 2.5H10l-.1-.7h-.3v-.2l.8-.1v.2H10zM11.4 1.5V2a.4.4 0 0 1 0 .3.5.5 0 0 1-.4 0 .4.4 0 0 1-.3 0 .4.4 0 0 1 0-.3v-.6h.2v.6a.2.2 0 0 0 0 .1.2.2 0 0 0 .1 0 .1.1 0 0 0 .1 0 .3.3 0 0 0 0-.1v-.6zM11.7 2.5l.1-1h.3v.7h.3v.3zM13.2 2.6v-.2h-.3l-.1.2h-.3l.5-1h.3l.2 1zm0-.4V2 2a.7.7 0 0 1 0-.1l-.2.4zM14.2 2a.2.2 0 0 0-.1 0 .4.4 0 0 0-.1.3v.3H14.4v.2a.5.5 0 0 1-.3 0 .4.4 0 0 1-.3-.2.5.5 0 0 1 0-.4.5.5 0 0 1 .1-.2.4.4 0 0 1 .2-.1.5.5 0 0 1 .3 0 .7.7 0 0 1 .2.1l-.1.2h-.1z"
        fill="#fff"
      />
      <path
        d="M14.3 3.2h-.1V3a.1.1 0 0 0 .2 0 .3.3 0 0 0 0-.1l.4-.9.2.1-.3.8a.5.5 0 0 1-.2.3.3.3 0 0 1-.2 0zM15.5 3.4l-.5-.2.4-1 .5.3v.2l-.4-.1v.1l.3.1-.1.2-.3-.1V3l.2.2zM15.7 3.4h.1a.1.1 0 0 1 .1 0 .1.1 0 0 1 0 .1.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.1zm.4 0l-.2-.2.2-.6.3.2zM7.4 20a.3.3 0 0 1-.2.2.3.3 0 0 1-.3 0l-.2.2-.2-.1.4-.9.3.2a.3.3 0 0 1 .2.2.3.3 0 0 1 0 .2zM7 20a.1.1 0 0 0 .1 0 .1.1 0 0 0 0-.1v-.2zM7.7 20.5l-.1.3h-.3l.4-1 .3.1c.2.1.3.3.2.5a.3.3 0 0 1-.2.1v.5h-.2v-.5zm0-.2h.1a.1.1 0 0 0 .2 0V20z"
        fill="#fff"
      />
      <path
        d="M8.8 21.3V21l-.3-.1v.2L8 21l.6-.9.4.1v1zm0-.4v-.2a.7.7 0 0 1 0-.2l-.1.3zM10.3 21.6H10V21a.6.6 0 0 0 0-.1v-.1.2l-.2.4h-.3v-1h.2v.8a1 1 0 0 1 0-.3 1.3 1.3 0 0 1 0-.2l.2-.3h.3v.7a1.6 1.6 0 0 1 0-.2l.2-.5h.3zM11.7 21.1a.5.5 0 0 1-.1.4.5.5 0 0 1-.4.1.5.5 0 0 1-.3-.1.5.5 0 0 1-.1-.4.5.5 0 0 1 .1-.4.6.6 0 0 1 .7 0 .6.6 0 0 1 .1.4zm-.7 0c0 .2.1.3.2.3a.2.2 0 0 0 .2 0 .3.3 0 0 0 0-.2.3.3 0 0 0 0-.3.1.1 0 0 0-.1 0c-.2 0-.3 0-.3.2zM12.3 21.9H12v-.2h.2a.3.3 0 0 0 0-.2v-.9h.2l.1.9a.5.5 0 0 1 0 .3.3.3 0 0 1-.3.1zM13.5 21.4l-.1-.1H13v.2h-.3l.1-1h.4l.5.9zm-.2-.3v-.2a.8.8 0 0 1-.1-.1v-.1.4zM14.6 21.1l-.7.2v-.1l.2-.7-.4.1v-.2l.7-.2v.2l-.3.7.4-.2zM15.4 20.3a.5.5 0 0 1 0 .4.6.6 0 0 1-.3.3h-.3l-.4-.8.3-.2a.5.5 0 0 1 .4 0 .4.4 0 0 1 .3.3zm-.3.1a.3.3 0 0 0 0-.2.2.2 0 0 0-.3 0l.2.5a.2.2 0 0 0 .2 0 .3.3 0 0 0 0-.3zM15.8 20v-.4l.3-.1v.6l.1.4-.2.1-.2-.3-.5-.4.2-.1z"
        fill="#fff"
      />
      <circle cx="21.2" cy="11.4" r=".5" fill="#fff" opacity=".5" />
      <circle cx="21" cy="13.2" r=".4" fill="#fff" opacity=".4" />
      <circle cx="20.6" cy="14.8" r=".3" fill="#fff" opacity=".3" />
      <circle cx="21" cy="9.6" r=".4" fill="#fff" />
      <circle cx="20.6" cy="8" r=".3" fill="#fff" />
      <circle cx="1.9" cy="11.4" r=".5" fill="#fff" opacity=".5" />
      <circle cx="2" cy="13.2" r=".4" fill="#fff" />
      <circle cx="2.5" cy="14.8" r=".3" fill="#fff" />
      <circle cx="2" cy="9.6" r=".4" fill="#fff" opacity=".4" />
      <circle cx="2.5" cy="8" r=".3" fill="#fff" opacity=".3" />
      <circle cx="11.5" cy="11.5" r="8" fill="#fbc53b" />
      <g clip-path="url(#badge2_a)">
        <path
          d="M13.2 5.9a.2.2 0 0 0-.3-.2.3.3 0 0 0-.4-.2.3.3 0 0 0-.4-.2.4.4 0 0 0-.1 0 .5.5 0 0 0 0-.2.5.5 0 0 0-.6-.5.4.4 0 0 0-.1 0 .5.5 0 0 0-.6-.5.5.5 0 0 0-.3.2.8.8 0 0 0-1.4.5.6.6 0 0 0-.5.3.2.2 0 0 0-.1 0 .3.3 0 0 0-.4.2.3.3 0 0 0-.2 0 .3.3 0 0 0-.3.3.3.3 0 0 0-.3.1.2.2 0 0 0-.1 0 .2.2 0 0 0-.3.3 6 6 0 0 0 1.1.2 9.1 9.1 0 0 0 2.6-.2 10.2 10.2 0 0 1 2.7-.1z"
          fill="#fff"
        />
        <path
          d="M9.8 5.4a.2.2 0 0 1 0 .1.2.2 0 0 1-.2.1.2.2 0 0 1-.1 0v-.2a.2.2 0 0 0 0 .2.2.2 0 0 0 .2 0 .2.2 0 0 0 .1 0 .3.3 0 0 0 0-.2zM10.6 4.8a.2.2 0 0 1 0 .2.2.2 0 0 1-.2 0 .3.3 0 0 1-.2 0 .4.4 0 0 1 0-.2.3.3 0 0 0 0 .2.3.3 0 0 0 .2 0 .3.3 0 0 0 .2 0 .3.3 0 0 0 0-.3zM11.4 5.4a.1.1 0 0 1 0 .1.3.3 0 0 1-.2.1.3.3 0 0 1-.2 0 .2.2 0 0 1 0-.1.4.4 0 0 1 0-.1.3.3 0 0 0 0 .1.2.2 0 0 0 .2.1.2.2 0 0 0 .2 0 .3.3 0 0 0 0-.2zM8.5 5.5a.1.1 0 0 1 0 .1.2.2 0 0 1-.1.1.2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2.2.2 0 0 0 0 .2.2.2 0 0 0 .1 0 .2.2 0 0 0 .2 0 .2.2 0 0 0 0-.2z"
          fill="#d6e8f2"
        />
        <path
          d="M19.2 7.7a.1.1 0 0 0-.1-.2.2.2 0 0 0-.2 0 .2.2 0 0 0-.2-.2.3.3 0 0 0-.3-.3.3.3 0 0 0-.4-.2.3.3 0 0 0-.2.1.4.4 0 0 0-.3-.1.4.4 0 0 0-.4.3.3.3 0 0 0-.2.1.2.2 0 0 0-.2.2.1.1 0 0 0-.1 0 .2.2 0 0 0-.2.1.2.2 0 0 0-.1.1.1.1 0 0 0-.2.1 2.5 2.5 0 0 0 .6.1 4.5 4.5 0 0 0 1.2 0 5.2 5.2 0 0 1 1.3-.1z"
          fill="#fff"
        />
        <path
          d="M17.5 7.4h-.1.1zM18 7a.1.1 0 0 1-.2 0 .1.1 0 0 0 0 .2.1.1 0 0 0 .1 0A.1.1 0 0 0 18 7zM18.3 7.4a.1.1 0 0 1-.2 0 .2.2 0 0 0 .1 0 .1.1 0 0 0 .2 0zM17 7.5h-.1-.1.1z"
          fill="#d6e8f2"
        />
        <path
          d="M8 7.2a.1.1 0 0 0-.1-.1.2.2 0 0 0-.1-.1.1.1 0 0 0-.2-.1.3.3 0 0 0-.3-.3h-.1a.3.3 0 0 0-.3-.2.3.3 0 0 0-.1 0 .4.4 0 0 0-.3 0 .4.4 0 0 0-.3.3.3.3 0 0 0-.3 0 .2.2 0 0 0-.2.2.2.2 0 0 0-.2.1.2.2 0 0 0-.2 0 .1.1 0 0 0 0 .2 3.3 3.3 0 0 0 .4 0 4.2 4.2 0 0 0 1.2 0 4.5 4.5 0 0 1 1.1 0z"
          fill="#fff"
        />
        <path
          d="M6.5 7h-.1zM6.9 6.7a.1.1 0 0 1-.2 0 .1.1 0 0 0 .2 0zM7.3 7h-.1A.1.1 0 0 1 7 7a.1.1 0 0 0 .2 0zM6 7h-.2.1z"
          fill="#d6e8f2"
        />
        <path
          fill="#fbb03b"
          d="M12.1 10.8h.3v-.4h-.3v-.1h.3v-.4h-.3v-.3H12V9l-.3.1v-.4.5h-.4v.4h-.1v.3h-.4v.4h.4v.1h-.4v.4h.4v2.5H11V11l-1 1v.3h-.2v-1.7h-.2v-.6h-1v.6h-.2v1.7H8v-3l-1.7.7v1.7h-.6v-.3h.4L5 10.6l-1.3.9h.5v1h-.5v-2.2H2.6L2.4 19l2.6-.2-.8-3.8 2.3 3.5h1.7l.3-1.4 5.6.3-1.8-4H12v-2.5z"
        />
        <path
          fill="#fbb03b"
          d="M20.2 8v.7h-.4v3h-.3v-1.3h-1.6v1.3h-.3V11H17v.7h-.3v-2h-.2v-.4H16v.3h-.2v1.5h-.3V9.6h-.1v-.3h-.6v.3h-.2v3.2H14v-.6H14v-.6h-.3V11l-1 .3v.3h-.2v.6h-.1l-.9 5.8 2.9-1.1.4.4v-.5l.5.7.1-2.6v-3.6h.3V15h1v-.5h2.6v.5H21V8h-.7z"
        />
        <g opacity=".1">
          <path
            d="M7.6 14.7a.9.9 0 1 0-1-1.5l-2 1.2a.9.9 0 1 0 1 1.5"
            fill="#53678e"
          />
          <path
            d="M7.2 15a.9.9 0 1 0-1-1.5l-1.9 1.2A.9.9 0 0 0 4 16a.9.9 0 0 0 1.2.3"
            fill="#236"
          />
          <g clip-path="url(#badge2_b)" fill="#236">
            <path d="M6.3 13.5l1.5-1v.1l-1.5 1zM6.5 13.7l1.5-1-1.5 1zM6.6 14L8 13l-1.5 1zM6.8 14.2l1.5-1-1.5 1zM6.9 14.4l1.5-1v.1l-1.5 1zM7.1 14.7l1.5-1-1.4 1zM7.2 15l1.5-1-1.5 1z" />
          </g>
          <path
            d="M7.2 13.8v-.1H6.4h-.1v.2a.2.2 0 0 0 0 .2h.1v.1H7V14a.6.6 0 0 0 0-.1h.3v-.2h-.1z"
            fill="#556289"
          />
          <rect
            x="4.3"
            y="14.6"
            width="2.8"
            height=".5"
            rx="0"
            transform="rotate(-33.1 5.7 14.8)"
            fill="#556289"
          />
          <circle cx="6.7" cy="14.2" r=".3" fill="#236" />
          <rect
            x="6.4"
            y="12.4"
            width="1.6"
            height=".9"
            rx=".5"
            transform="rotate(-33.1 7.2 12.9)"
            fill="#f18c2d"
          />
          <rect
            x="6.6"
            y="12.3"
            width="1.5"
            height=".9"
            rx=".5"
            transform="rotate(-33.1 7.4 12.7)"
            fill="#f8ad3c"
          />
          <rect
            x="6.8"
            y="12.4"
            width="1.2"
            height=".6"
            rx=".3"
            transform="rotate(-33.1 7.4 12.7)"
            fill="#f0f9fe"
          />
          <path
            d="M7.2 13a.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2h.1l.2.2zM7.7 12.8a.2.2 0 0 1-.2-.3l.2.3z"
            fill="#c5d2eb"
          />
          <circle cx="7.6" cy="12.6" r=".2" fill="#236" />
          <circle cx="7.2" cy="12.9" r=".2" fill="#236" />
          <rect
            x="5"
            y="13"
            width="1.6"
            height="1.2"
            rx="0"
            transform="rotate(-33.1 5.8 13.6)"
            fill="#f0f9fe"
          />
          <circle cx="6.1" cy="13" r=".1" fill="#c5d2eb" />
          <circle cx="5.8" cy="13.2" r=".1" fill="#c5d2eb" />
          <circle cx="5.5" cy="13.3" r=".1" fill="#c5d2eb" />
          <circle cx="5.2" cy="13.5" r=".1" fill="#c5d2eb" />
          <circle cx="6.3" cy="13.3" r=".1" fill="#c5d2eb" />
          <circle cx="6" cy="13.4" r=".1" fill="#c5d2eb" />
          <circle cx="5.7" cy="13.7" r=".1" fill="#c5d2eb" />
          <circle cx="5.4" cy="13.8" r=".1" fill="#c5d2eb" />
          <circle cx="6.5" cy="13.6" r=".1" fill="#c5d2eb" />
          <circle cx="6.2" cy="13.8" r=".1" fill="#c5d2eb" />
          <circle cx="5.9" cy="13.9" r=".1" fill="#c5d2eb" />
          <circle cx="5.6" cy="14.1" r=".1" fill="#c5d2eb" />
          <path
            d="M5.3 14.3l-1.8 1.2-.5-.7a.3.3 0 0 1 .1-.5l1.6-1z"
            fill="#c5d2eb"
          />
          <rect
            x="3.1"
            y="13.9"
            width="1.7"
            height=".8"
            rx="0"
            transform="rotate(-33.1 4 14.4)"
            fill="#b7c4de"
          />
          <rect
            x="3.4"
            y="14.3"
            width="1.4"
            height=".5"
            rx="0"
            transform="rotate(-33.1 4 14.6)"
            fill="#c5d2eb"
          />
          <rect
            x="3.3"
            y="14.4"
            width="1.4"
            height=".5"
            rx="0"
            transform="rotate(-33.1 4 14.6)"
            fill="#f0f9fe"
          />
          <circle cx="4.3" cy="14.4" r=".2" fill="#f8ad3c" />
          <circle cx="3.6" cy="14.8" r=".2" fill="#c5d2eb" />
          <circle cx="4.3" cy="14.4" r=".1" fill="#236" />
          <circle cx="4" cy="14.6" r=".1" fill="#236" />
          <circle cx="3.6" cy="14.8" r=".1" fill="#236" />
          <path
            d="M5.5 13.1l-2 1.4a1.6 1.6 0 0 1-.1-1.4l.6-.5a1 1 0 0 1 .2-.1L5 12z"
            fill="#b7c4de"
          />
          <path d="M6 12.8a1.6 1.6 0 0 0-1-.7l.1 1.3z" fill="#c5d2eb" />
          <path
            d="M4.8 13.7l-2 1.3a1.6 1.6 0 0 1-.2-1.3L3 13a.7.7 0 0 1 .3-.1l.8-.4z"
            fill="#f0f9fe"
          />
          <path
            d="M5.3 13.3l-1.1-.7a1.5 1.5 0 0 0 .1 1.3zM3.6 14.4a2 2 0 0 1-.3-1.4h-.1a2 2 0 0 0 .3 1.5z"
            fill="#c4d9ef"
          />
          <path d="M5.7 12l.3-.2.3.4-.4.2-.2-.4z" fill="#7aa9d7" />
          <path d="M5.6 12l.4-.2.2.4-.3.2-.3-.3z" fill="#5e97ce" />
          <path
            d="M5.8 12.3v.2l.1.3v.1l.1.2a.2.2 0 0 0 .3 0 .2.2 0 0 0 0-.3v-.1a.1.1 0 0 1 0-.1v-.3L6 12a.2.2 0 0 0-.3-.1.2.2 0 0 0 0 .3z"
            fill="#c5d2eb"
          />
          <path
            d="M5.7 12.3v.2l.1.4.1.2a.2.2 0 0 0 .3 0 .2.2 0 0 0 .1-.2v-.2l-.2-.4V12a.2.2 0 0 0-.3 0 .2.2 0 0 0-.1.3z"
            fill="#fff"
          />
          <circle cx="6.1" cy="13" r=".1" fill="#c5d2eb" />
          <path d="M4.9 11.4a.5.5 0 1 0 .5.8l.7-.4-.6-.9z" fill="#5e97ce" />
          <path
            d="M4.6 12.1a.5.5 0 0 1 .2-.7l.7-.5.3.4zM5.6 12.1l.3-.2.3.4-.4.2-.2-.4z"
            fill="#7aa9d7"
          />
          <path d="M5.5 12.2l.3-.3.3.4-.3.2-.3-.4z" fill="#5e97ce" />
          <circle cx="5.8" cy="12.3" r=".1" fill="#4184c5" />
          <path d="M4.7 12.7l.4-.3.2.4-.3.3-.3-.5z" fill="#7aa9d7" />
          <path d="M4.7 12.7l.3-.2.3.3-.4.3-.2-.4z" fill="#5e97ce" />
          <path
            d="M4.8 13h.1v.5l.1.2a.2.2 0 0 0 .3 0 .2.2 0 0 0 .1-.3v-.1l-.2-.4v-.2a.2.2 0 0 0-.3 0 .2.2 0 0 0-.1.2z"
            fill="#c5d2eb"
          />
          <path
            d="M4.7 13l.1.1v.1l.1.3v.2a.2.2 0 0 0 .4 0 .2.2 0 0 0 0-.2V13l-.2-.2a.2.2 0 0 0-.3 0 .2.2 0 0 0 0 .2z"
            fill="#fff"
          />
          <path d="M4 12a.5.5 0 0 0 .5.8l.6-.4-.5-.8z" fill="#4184c5" />
          <path d="M3.8 12.7a.5.5 0 0 1 .1-.7l.7-.4.3.4z" fill="#5e97ce" />
          <path d="M4.6 12.7l.3-.2.3.3-.4.3-.2-.4z" fill="#7aa9d7" />
          <path d="M4.5 12.8l.4-.3.2.4-.3.2-.2-.3z" fill="#5e97ce" />
          <circle cx="4.9" cy="12.9" r=".1" fill="#4184c5" />
          <rect
            x="4.7"
            y="13.5"
            width=".7"
            height=".4"
            rx="0"
            transform="rotate(-33.1 5 13.7)"
            fill="#f0f9fe"
          />
          <circle cx="5.2" cy="13.6" r=".1" fill="#c5d2eb" />
          <path d="M7.5 13.4l1.1-.7.4.5-1.2.8-.3-.6z" fill="#236" />
          <path
            d="M8.5 12.7a.1.1 0 0 1 .2 0l.2.3a.2.2 0 0 1 0 .2z"
            fill="#5e97ce"
          />
          <path
            d="M7.7 14.2a.1.1 0 0 1-.2 0l-.2-.3a.1.1 0 0 1 0-.2l.2-.1-.1-.1a.3.3 0 0 0-.5-.2l-.7.5.7 1 1-.6V14z"
            fill="#c5d2eb"
          />
          <path d="M5.9 14l.9-.6.7 1-1 .6-.6-1z" fill="#f0f9fe" />
          <path
            d="M6.3 14.6l.7-.4.1.2-.7.5-.2-.3zM6 14.2l.7-.4.1.2-.7.4-.2-.3z"
            fill="#5e97ce"
          />
          <path d="M7 13.9l.3-.2.4.5-.3.2L7 14z" fill="#236" />
          <path d="M7.3 13.6l1-.7.4.5-1 .8-.4-.5z" fill="#7aa9d7" />
          <path
            d="M8.7 13.4a.1.1 0 0 1-.2 0l-.2-.3a.1.1 0 0 1 0-.2zM7 14l.6-.3.1.2-.5.3L7 14z"
            fill="#5e97ce"
          />
          <path
            d="M6.5 15.4a.9.9 0 0 0-1-1.5l-2 1.3a.9.9 0 0 0 1 1.5"
            fill="#53678e"
          />
          <path
            d="M6 15.7a.9.9 0 1 0-1-1.5l-1.9 1.3a.9.9 0 1 0 1 1.4"
            fill="#236"
          />
          <path
            d="M5.3 14.5a.5.5 0 0 1 .7.1.5.5 0 0 1-.2.8L4 16.6a.5.5 0 0 1-.7-.1.5.5 0 0 1 .1-.8l1.9-1.2m-.1-.2l-2 1.3a.7.7 0 1 0 .9 1.2L6 15.6a.7.7 0 0 0-.8-1.3z"
            fill="#556289"
          />
          <g clip-path="url(#badge2_c)" fill="#236">
            <path d="M5.2 14.2l1.5-1v.1l-1.5 1zM5.3 14.4l1.5-1v.1l-1.5 1zM5.5 14.7l1.5-1v.1l-1.5 1zM5.6 15L7 14l-1.5 1zM5.8 15.2l1.5-1v.1l-1.4 1zM5.9 15.5l1.5-1-1.5 1zM6 15.6l1.6-1v.1l-1.5 1z" />
          </g>
          <g clip-path="url(#badge2_d)">
            <path fill="#f8623c" d="M4.5 16.5l-.8-1.2h.8v1.2z" />
            <path fill="#f8623c" d="M4.5 16.6l-.9-1.3h.1l.8 1.2v.1z" />
            <path fill="#f8623c" d="M4.5 16.8l-1-1.5h.1l1 1.3v.2z" />
            <path
              fill="#f8623c"
              d="M4.5 16.9l-1-1.6 1 1.5zM4.5 16.9l-1.1-1.6 1 1.6z"
            />
            <path fill="#f8623c" d="M4.4 17l-1.1-1.7L4.5 17z" />
            <path
              fill="#f8633c"
              d="M4.4 17l-1.2-1.7L4.5 17zM4.3 17L3 15.3h.1L4.3 17z"
            />
            <path
              fill="#f8633c"
              d="M4.3 17h-.1L3 15.4h.1L4.2 17zM3 15.4L4.2 17z"
            />
            <path fill="#f8643b" d="M2.9 15.4L4.3 17H4z" />
            <path fill="#f8643b" d="M2.8 15.5H3l1.2 1.7z" />
            <path fill="#f8653b" d="M2.8 15.5l1.3 1.7H4z" />
            <path fill="#f7653b" d="M2.7 15.5L4 17.2h-.1z" />
            <path fill="#f7663b" d="M2.6 15.6h.1L4 17.3z" />
            <path fill="#f7663a" d="M2.6 15.6l1.2 1.7z" />
            <path fill="#f7673a" d="M2.5 15.7h.1l1.2 1.7z" />
            <path fill="#f7683a" d="M2.4 15.7h.1l1.2 1.7h-.1z" />
            <path fill="#f7693a" d="M2.4 15.8h.1l1.2 1.7z" />
            <path fill="#f76939" d="M2.3 15.8h.1l1.2 1.7h-.1z" />
            <path fill="#f76a39" d="M2.3 15.8l1.3 1.7h-.1z" />
            <path fill="#f66b39" d="M2.2 15.9h.1l1.2 1.7z" />
            <path fill="#f66c38" d="M2.2 15.9l1.3 1.7h-.1z" />
            <path fill="#f66d38" d="M2.1 16h.1l1.2 1.7z" />
            <path fill="#f66e38" d="M2 16h.1l1.2 1.7h-.1z" />
            <path fill="#f67037" d="M2 16l1.3 1.7h-.1z" />
            <path fill="#f67137" d="M2 16.1l1.2 1.7z" />
            <path fill="#f57236" d="M1.9 16l1.3 1.8H3z" />
            <path fill="#f57336" d="M1.8 16.2H2l1.2 1.7z" />
            <path fill="#f57535" d="M1.7 16.3l.1-.1L3 17.9l-.1.1z" />
            <path fill="#f57635" d="M3 18h-.1l-1.2-1.7L3 17.8z" />
            <path fill="#f47834" d="M2.9 18h-.1l-1-1.6 1 1.6z" />
            <path fill="#f47934" d="M2.8 18l-1-1.4v-.2l1 1.6z" />
            <path fill="#f47b33" d="M2.6 18l-.9-1.3v-.1l1 1.4z" />
            <path fill="#f47d32" d="M2.5 18l-.8-1.2 1 1.3h-.2z" />
            <path fill="#f37e32" d="M2.5 18l-.8-1v-.2l.8 1.3z" />
            <path fill="#f38031" d="M2.4 18l-.7-.9V17l.8 1h-.1z" />
            <path fill="#f38231" d="M2.3 18l-.6-.8v-.1l.7 1h-.1z" />
            <path fill="#f28430" d="M2.2 18l-.5-.6v-.2l.6.9h-.1z" />
            <path fill="#f2862f" d="M2.1 18l-.4-.5v-.1l.5.7z" />
            <path fill="#f2882e" d="M2 18l-.3-.4v-.1l.4.6z" />
            <path fill="#f18a2e" d="M2 18l-.3-.3.3.4z" />
            <path fill="#f18c2d" d="M1.8 18v-.2l.1.3zM1.7 17.9l.1.2v-.2z" />
          </g>
          <path
            d="M4.2 15.8H4v-.2l-.1.1h-.4v.1h-.2v.1h.1v.2H3V16.5l.1-.1h.4v-.1-.2h.6v-.1z"
            fill="#f39336"
          />
          <circle cx="3.7" cy="16.2" r=".4" fill="#ef7844" />
          <path
            d="M6.1 14.6H6v-.1h-.7l-.3.1a.2.2 0 0 0 0 .1v.5h.1v.2-.1h.1v.2H5.6v-.1a.6.6 0 0 0 0-.1h.6a.3.3 0 0 0 0-.1v-.6z"
            fill="#f0f9fe"
          />
          <circle cx="5.6" cy="14.9" r=".4" fill="#c5d2eb" />
          <rect
            x="3.2"
            y="15.3"
            width="2.8"
            height=".5"
            rx=".3"
            transform="rotate(-33.1 4.6 15.6)"
            fill="#f0f9fe"
          />
          <circle cx="3.7" cy="16.2" r=".2" fill="#f8ad3c" />
          <circle cx="5.6" cy="14.9" r=".2" fill="#f8ad3c" />
          <circle cx="5.6" cy="14.9" r=".1" fill="#236" />
          <circle cx="4.1" cy="15.9" r=".1" fill="#236" />
          <circle cx="4.4" cy="15.7" r=".1" fill="#236" />
          <circle cx="5.1" cy="15.2" r=".1" fill="#236" />
          <circle cx="4.8" cy="15.4" r=".1" fill="#236" />
          <circle cx="3.7" cy="16.2" r=".1" fill="#236" />
          <rect
            x="4.7"
            y="13.5"
            width="1.6"
            height=".9"
            rx=".5"
            transform="rotate(-33.1 5.5 14)"
            fill="#f18c2d"
          />
          <rect
            x="4.9"
            y="13.4"
            width="1.5"
            height=".9"
            rx=".5"
            transform="rotate(-33.1 5.7 13.8)"
            fill="#f8ad3c"
          />
          <rect
            x="5.1"
            y="13.5"
            width="1.2"
            height=".6"
            rx=".3"
            transform="rotate(-33.1 5.7 13.8)"
            fill="#f0f9fe"
          />
          <path
            d="M5.5 14.2a.2.2 0 0 1-.2-.1.2.2 0 0 1 0-.3l.3.3zM6 13.9a.2.2 0 0 1-.3 0 .2.2 0 0 1 0-.3h.1l.2.3z"
            fill="#c5d2eb"
          />
          <circle cx="5.9" cy="13.7" r=".2" fill="#236" />
          <circle cx="5.5" cy="14" r=".2" fill="#236" />
          <path
            d="M3.5 11.2a.4.4 0 0 1 .2-.5c.3-.2.4 0 .4 0a1 1 0 0 1 0 .2l-.2.2z"
            fill="#ffc800"
          />
          <path
            d="M5.8 10.8h-.2a.5.5 0 0 1-.1.1l-.2.2a5.3 5.3 0 0 0-1 .8 1.5 1.5 0 0 0-.5.8l-.2-.3-.2-.2a1.2 1.2 0 0 1 0-.2 1.1 1.1 0 0 1 .3-1.1l.1-.2.2-.2a1 1 0 0 1 .5-.2.4.4 0 0 1 .1 0 1 1 0 0 1 .8 0c.3.2.4.5.4.5z"
            fill="#f8ad3c"
          />
          <path
            d="M5.6 10.9h-.1l-.4.3-.2.1s-.1-.3-.4-.5a1 1 0 0 0-.8-.1h.1l.2-.2a2 2 0 0 1 .3-.1 1.1 1.1 0 0 1 1 0 .8.8 0 0 1 .3.5z"
            fill="#fff"
            opacity=".6"
          />
          <path
            d="M5.3 10.4a1.4 1.4 0 0 0-.9-.1 1.6 1.6 0 0 0-.4.2h-.1l-.2.2H4a1 1 0 0 1 .7.1c.3.2.4.4.4.5l.2-.2.5-.3c.1 0 0-.2-.4-.4z"
            fill="#f8ad3c"
          />
          <path
            d="M3.8 12.7a1.3 1.3 0 0 1 .4-.8 5.3 5.3 0 0 1 1-.8l.6-.3c.2 0-.1-.3-.4-.4a1 1 0 0 0-.8-.1 1 1 0 0 1 .7.4l-1 .9c-.5.6-.8 1-.5 1z"
            fill="#f18c2d"
          />
          <path
            d="M6.2 10.5l-.4.3a.6.6 0 0 0-.2 0 3.2 3.2 0 0 0-.4.2 2.5 2.5 0 0 0-.5.4l-.4.3a2 2 0 0 1 .3-.5 6.1 6.1 0 0 1 .9-.6l.1-.1.5-.2v.2z"
            fill="#ff9600"
          />
          <path
            d="M5.5 10.6l.1.3a3.2 3.2 0 0 0-.4.2 2.5 2.5 0 0 0-.5.3v-.1a6.1 6.1 0 0 1 .8-.7z"
            fill="#fff"
            opacity=".5"
          />
          <path
            d="M5.7 10.6a3.3 3.3 0 0 0-1.4 1.2 7.7 7.7 0 0 1 1-.7 1.4 1.4 0 0 1 .5-.2c.1-.1.7-.8-.1-.3z"
            fill="#cc741d"
          />
          <circle cx="4.8" cy="12" r=".5" fill="#4184c5" />
          <circle cx="4.8" cy="12" r=".4" fill="#f0f9fe" />
          <circle cx="4.8" cy="12" r=".2" fill="#c5d2eb" />
          <circle cx="4.8" cy="12" r=".1" fill="#fff" />
          <path d="M4.7 12.1a.1.1 0 0 0 .2 0 .1.1 0 0 0 0-.1z" fill="#454f5a" />
          <circle cx="5.8" cy="11.3" r=".5" fill="#4184c5" />
          <circle cx="5.8" cy="11.3" r=".4" fill="#f0f9fe" />
          <circle cx="5.7" cy="11.4" r=".2" fill="#c5d2eb" />
          <circle cx="5.7" cy="11.4" r=".1" fill="#fff" />
          <path d="M5.7 11.5a.1.1 0 0 0 .1 0 .1.1 0 0 0 0-.1z" fill="#454f5a" />
        </g>
        <g opacity=".1">
          <path
            d="M10 13a.9.9 0 0 0-1-1.4l-2 1.2a.9.9 0 1 0 1 1.5"
            fill="#53678e"
          />
          <path
            d="M9.5 13.3a.9.9 0 0 0 .3-1.2.9.9 0 0 0-1.3-.2L6.6 13a.9.9 0 0 0-.2 1.2.9.9 0 0 0 1.2.3"
            fill="#236"
          />
          <g clip-path="url(#badge2_e)" fill="#236">
            <path d="M8.6 12l1.5-1-1.4 1zM8.8 12l1.5-.9-1.5 1zM8.9 12.3l1.5-1v.1l-1.5 1zM9 12.6l1.6-1-1.5 1zM9.2 12.8l1.5-1v.1l-1.5 1zM9.4 13l1.5-.9-1.4 1zM9.4 13.3l1.5-1v.1l-1.4 1z" />
          </g>
          <path
            d="M9.5 12.2h-.1V12h-.1L9 12H8.6v.1h-.2v.5H8.9v.1H9v-.2h.1v-.2h.5a.1.1 0 0 1 0-.1V12v.1z"
            fill="#556289"
          />
          <rect
            x="6.7"
            y="13"
            width="2.8"
            height=".5"
            rx="0"
            transform="rotate(-33.2 8 13.2)"
            fill="#556289"
          />
          <circle cx="9" cy="12.6" r=".3" fill="#236" />
          <rect
            x="8.7"
            y="10.8"
            width="1.6"
            height=".9"
            rx=".5"
            transform="rotate(-33.1 9.5 11.3)"
            fill="#f18c2d"
          />
          <rect
            x="9"
            y="10.7"
            width="1.5"
            height=".9"
            rx=".5"
            transform="rotate(-33.2 9.6 11)"
            fill="#f8ad3c"
          />
          <rect
            x="9.1"
            y="10.8"
            width="1.2"
            height=".6"
            rx=".3"
            transform="rotate(-33.1 9.7 11.1)"
            fill="#f0f9fe"
          />
          <path
            d="M9.6 11.4a.2.2 0 0 1-.2-.3l.2.4zM10 11.2a.2.2 0 0 1-.3 0 .2.2 0 0 1 .1-.3l.3.3z"
            fill="#c5d2eb"
          />
          <circle cx="9.9" cy="11" r=".2" fill="#236" />
          <circle cx="9.5" cy="11.3" r=".2" fill="#236" />
          <rect
            x="7.3"
            y="11.4"
            width="1.6"
            height="1.2"
            rx="0"
            transform="rotate(-33.1 8.2 12)"
            fill="#f0f9fe"
          />
          <circle cx="8.4" cy="11.4" r=".1" fill="#c5d2eb" />
          <circle cx="8.2" cy="11.6" r=".1" fill="#c5d2eb" />
          <circle cx="7.9" cy="11.8" r=".1" fill="#c5d2eb" />
          <circle cx="7.6" cy="11.9" r=".1" fill="#c5d2eb" />
          <circle cx="8.7" cy="11.7" r=".1" fill="#c5d2eb" />
          <circle cx="8.3" cy="11.8" r=".1" fill="#c5d2eb" />
          <circle cx="8.1" cy="12.1" r=".1" fill="#c5d2eb" />
          <circle cx="7.8" cy="12.2" r=".1" fill="#c5d2eb" />
          <circle cx="8.8" cy="12" r=".1" fill="#c5d2eb" />
          <circle cx="8.5" cy="12.2" r=".1" fill="#c5d2eb" />
          <circle cx="8.3" cy="12.3" r=".1" fill="#c5d2eb" />
          <circle cx="8" cy="12.5" r=".1" fill="#c5d2eb" />
          <path
            d="M7.7 12.7l-1.9 1.2-.5-.7a.3.3 0 0 1 .1-.5l1.6-1z"
            fill="#c5d2eb"
          />
          <rect
            x="5.4"
            y="12.3"
            width="1.7"
            height=".8"
            rx="0"
            transform="rotate(-33.1 6.3 12.8)"
            fill="#b7c4de"
          />
          <rect
            x="5.7"
            y="12.7"
            width="1.4"
            height=".5"
            rx="0"
            transform="matrix(.84 -.55 .55 .84 -6 5.6)"
            fill="#c5d2eb"
          />
          <rect
            x="5.6"
            y="12.8"
            width="1.4"
            height=".5"
            rx="0"
            transform="rotate(-33.1 6.3 13)"
            fill="#f0f9fe"
          />
          <circle cx="6.7" cy="12.8" r=".2" fill="#f8ad3c" />
          <circle cx="6" cy="13.3" r=".2" fill="#c5d2eb" />
          <circle cx="6.7" cy="12.8" r=".1" fill="#236" />
          <circle cx="6.3" cy="13" r=".1" fill="#236" />
          <circle cx="6" cy="13.3" r=".1" fill="#236" />
          <path
            d="M7.8 11.5l-2 1.4a1.5 1.5 0 0 1-.1-1.4l.6-.5a1.3 1.3 0 0 1 .2-.1l.8-.4z"
            fill="#b7c4de"
          />
          <path d="M8.4 11.2a1.6 1.6 0 0 0-1.1-.7l.1 1.3z" fill="#c5d2eb" />
          <path
            d="M7 12l-2 1.4A1.6 1.6 0 0 1 5 12l.6-.6a.6.6 0 0 1 .2-.1l.8-.4z"
            fill="#f0f9fe"
          />
          <path
            d="M7.6 11.7L6.5 11a1.5 1.5 0 0 0 .2 1.3zM6 12.8a2 2 0 0 1-.3-1.4h-.2A2.2 2.2 0 0 0 6 13z"
            fill="#c4d9ef"
          />
          <path d="M8 10.4l.4-.2.2.4-.3.2-.2-.4z" fill="#7aa9d7" />
          <path d="M7.9 10.5l.4-.2.2.3-.3.2-.2-.3z" fill="#5e97ce" />
          <path
            d="M8 10.7l.2.2v.3a.1.1 0 0 0 0 .1l.1.1a.2.2 0 0 0 .3.1.2.2 0 0 0 0-.3v-.1a.1.1 0 0 1 0-.1v-.3l-.2-.2a.2.2 0 0 0-.3 0 .2.2 0 0 0 0 .2z"
            fill="#c5d2eb"
          />
          <path
            d="M8 10.8v.1l.1.4.1.2a.2.2 0 0 0 .3 0 .2.2 0 0 0 .1-.2V11l-.1-.4-.1-.2a.2.2 0 0 0-.3 0 .2.2 0 0 0-.1.3z"
            fill="#fff"
          />
          <circle cx="8.4" cy="11.4" r=".1" fill="#c5d2eb" />
          <path d="M7.2 9.8a.5.5 0 1 0 .5.8l.7-.4-.6-.9z" fill="#5e97ce" />
          <path
            d="M7 10.5a.5.5 0 0 1 .2-.7l.7-.5.3.4zM7.9 10.5l.4-.2.2.3-.4.3-.2-.4z"
            fill="#7aa9d7"
          />
          <path d="M7.8 10.6l.4-.3.2.4-.3.2-.3-.4z" fill="#5e97ce" />
          <circle cx="8.1" cy="10.7" r=".1" fill="#4184c5" />
          <path d="M7 11l.4-.2.2.4-.3.2-.2-.4z" fill="#7aa9d7" />
          <path d="M7 11.1l.4-.2.2.4-.3.2-.2-.4z" fill="#5e97ce" />
          <path
            d="M7.1 11.3l.1.2v.4l.2.2a.2.2 0 0 0 .3 0 .2.2 0 0 0 0-.3v-.1l-.1-.4-.1-.2a.2.2 0 0 0-.3-.1.2.2 0 0 0 0 .3z"
            fill="#c5d2eb"
          />
          <path
            d="M7 11.4l.2.1v.4l.1.2a.2.2 0 0 0 .3 0 .2.2 0 0 0 0-.2v-.5a.3.3 0 0 0 0-.1l-.1-.2a.2.2 0 0 0-.3 0 .2.2 0 0 0-.1.3z"
            fill="#fff"
          />
          <path d="M6.2 10.4a.5.5 0 0 0 .6.8l.6-.4L7 10z" fill="#4184c5" />
          <path d="M6.1 11a.5.5 0 0 1 .1-.6L7 10l.3.4z" fill="#5e97ce" />
          <path d="M7 11.2l.3-.3.2.4-.3.2-.3-.3z" fill="#7aa9d7" />
          <path d="M6.9 11.2l.4-.3.2.4-.3.2-.3-.4z" fill="#5e97ce" />
          <circle cx="7.2" cy="11.3" r=".1" fill="#4184c5" />
          <rect
            x="7"
            y="11.9"
            width=".7"
            height=".4"
            rx="0"
            transform="rotate(-33.1 7.4 12)"
            fill="#f0f9fe"
          />
          <circle cx="7.5" cy="12" r=".1" fill="#c5d2eb" />
          <path d="M9.7 11.8l1.2-.7.3.5-1.2.7-.3-.5z" fill="#236" />
          <path
            d="M10.8 11.1a.1.1 0 0 1 .2 0l.2.3a.2.2 0 0 1 0 .2z"
            fill="#5e97ce"
          />
          <path
            d="M10 12.6a.1.1 0 0 1-.2 0l-.2-.3a.1.1 0 0 1 0-.2l.2-.1v-.1a.3.3 0 0 0-.6-.2l-.6.5.6 1 1-.6z"
            fill="#c5d2eb"
          />
          <path d="M8.2 12.4l.9-.6.7 1-1 .6-.6-1z" fill="#f0f9fe" />
          <path
            d="M8.6 13l.7-.4.1.2-.7.5-.2-.3zM8.4 12.6L9 12l.1.3-.7.4-.2-.3z"
            fill="#5e97ce"
          />
          <path d="M9.3 12.3l.4-.2.3.5-.3.2-.3-.5z" fill="#236" />
          <path d="M9.6 12l1.1-.7.4.5-1.2.8-.3-.5z" fill="#7aa9d7" />
          <path
            d="M11 11.8a.1.1 0 0 1-.1 0l-.2-.3a.1.1 0 0 1 0-.2zM9.4 12.4l.5-.3.1.2-.5.3-.1-.2z"
            fill="#5e97ce"
          />
          <path
            d="M8.8 13.8a.9.9 0 0 0-1-1.5l-2 1.3a.9.9 0 0 0 1 1.5"
            fill="#53678e"
          />
          <path
            d="M8.4 14a.9.9 0 1 0-1-1.4l-2 1.3a.9.9 0 0 0-.2 1.2.9.9 0 0 0 1.3.2"
            fill="#236"
          />
          <path
            d="M7.6 12.9a.5.5 0 0 1 .7.2.5.5 0 0 1-.1.7l-2 1.2a.5.5 0 0 1-.5-.9l1.9-1.2m-.1-.2l-2 1.3a.7.7 0 0 0-.1 1 .7.7 0 0 0 1 .2L8.3 14a.7.7 0 0 0 .2-1 .7.7 0 0 0-1-.2z"
            fill="#556289"
          />
          <g clip-path="url(#badge2_f)" fill="#236">
            <path d="M7.5 12.6l1.5-1v.1l-1.5 1zM7.6 12.8l1.5-1v.1l-1.5 1zM7.8 13.1l1.5-1v.1l-1.5 1zM8 13.3l1.5-1-1.5 1zM8.1 13.6l1.5-1v.1l-1.4 1zM8.3 13.8l1.5-1-1.5 1zM8.3 14l1.5-1v.1l-1.5 1z" />
          </g>
          <g clip-path="url(#badge2_g)">
            <path
              fill="#f8623c"
              d="M6.8 15L6 13.6h.8V15zM6.8 15L6 13.8l.8 1.2v.2z"
            />
            <path
              fill="#f8623c"
              d="M6.8 15.2l-1-1.5H6l.8 1.4zM6.8 15.3l-1-1.6 1 1.5zM6.8 15.3l-1.1-1.6 1.1 1.6z"
            />
            <path fill="#f8623c" d="M6.8 15.3h-.1l-1-1.6 1 1.6z" />
            <path
              fill="#f8633c"
              d="M6.7 15.3l-1.2-1.6h.1l1 1.7zM6.6 15.4l-1.2-1.7h.1l1.1 1.7z"
            />
            <path fill="#f8633c" d="M6.6 15.4l-1.3-1.7h.1l1.2 1.7z" />
            <path fill="#f8633c" d="M5.3 13.8h.1l1.2 1.7h-.1z" />
            <path
              fill="#f8643b"
              d="M5.2 13.8l1.3 1.7h-.1zM5.1 14l.1-.1 1.2 1.7z"
            />
            <path fill="#f8653b" d="M5.1 13.9l1.3 1.7h-.1z" />
            <path fill="#f7653b" d="M5 14h.1l1.2 1.7z" />
            <path fill="#f7663b" d="M5 14h.1l1.2 1.7h-.1z" />
            <path fill="#f7663a" d="M4.9 14l1.3 1.7H6z" />
            <path fill="#f7673a" d="M4.8 14.1H5l1.2 1.7z" />
            <path fill="#f7683a" d="M4.8 14.1l1.3 1.7H6z" />
            <path fill="#f7693a" d="M4.7 14.2h.1L6 15.8z" />
            <path fill="#f76939" d="M4.7 14.2h.1L6 15.8h-.1z" />
            <path fill="#f76a39" d="M4.6 14.2L6 15.9h-.1z" />
            <path fill="#f66b39" d="M4.5 14.3h.1L5.8 16z" />
            <path fill="#f66c38" d="M4.5 14.3L5.9 16h-.1z" />
            <path fill="#f66d38" d="M4.4 14.4h.1L5.7 16z" />
            <path fill="#f66e38" d="M4.4 14.4L5.8 16h-.1z" />
            <path fill="#f67037" d="M4.4 14.5l1.2 1.7z" />
            <path fill="#f67137" d="M4.2 14.5h.1l1.2 1.7z" />
            <path fill="#f57236" d="M4.2 14.5l1.3 1.7h-.1z" />
            <path fill="#f57336" d="M4.1 14.6h.1l1.2 1.7z" />
            <path fill="#f57535" d="M4.1 14.6l1.3 1.7h-.1z" />
            <path fill="#f57635" d="M5.2 16.3L4 14.8l1.2 1.6z" />
            <path fill="#f47834" d="M5.2 16.4L4 15v-.2l1.2 1.7z" />
            <path fill="#f47934" d="M5.1 16.4L4 15v-.2l1 1.6z" />
            <path fill="#f47b33" d="M5 16.4l-1-1.3V15l1 1.4z" />
            <path fill="#f47d32" d="M4.9 16.4L4 15.3l1 1.3h-.1z" />
            <path fill="#f37e32" d="M4.8 16.4l-.8-1v-.2l.9 1.3h-.1z" />
            <path fill="#f38031" d="M4.7 16.4l-.7-.9v-.1l.8 1h-.1z" />
            <path fill="#f38231" d="M4.6 16.4l-.5-.8v-.1l.6 1z" />
            <path fill="#f28430" d="M4.5 16.4l-.5-.6v-.2l.6.8z" />
            <path fill="#f2862f" d="M4.4 16.4L4 16v-.1l.5.6z" />
            <path fill="#f2882e" d="M4.3 16.4L4 16V16l.4.5z" />
            <path fill="#f18a2e" d="M4.3 16.4l-.3-.2V16l.3.4z" />
            <path fill="#f18c2d" d="M4.2 16.4l-.2-.1v-.1l.3.3h-.1z" />
            <path fill="#f18c2d" d="M4 16.3l.2.1H4v-.1z" />
          </g>
          <path
            d="M6.6 14.3v-.1h-.1V14H6V14H5.6v.1h-.2v.1h.1v.5l.1-.1h.4v-.1-.2h.4v-.1z"
            fill="#f39336"
          />
          <circle cx="6" cy="14.6" r=".4" fill="#ef7844" />
          <path
            d="M8.5 13h-.1v-.2h-.8V13.2a.2.2 0 0 0 0 .1v.1h.2v.1H8v.5h.1l.1-.1h.1v-.1a.6.6 0 0 0 0-.1h.1v-.1h.1V13z"
            fill="#f0f9fe"
          />
          <circle cx="7.9" cy="13.3" r=".4" fill="#c5d2eb" />
          <rect
            x="5.5"
            y="13.7"
            width="2.8"
            height=".5"
            rx=".3"
            transform="rotate(-33.1 7 14)"
            fill="#f0f9fe"
          />
          <circle cx="6" cy="14.6" r=".2" fill="#f8ad3c" />
          <circle cx="7.9" cy="13.3" r=".2" fill="#f8ad3c" />
          <circle cx="7.9" cy="13.3" r=".1" fill="#236" />
          <circle cx="6.4" cy="14.3" r=".1" fill="#236" />
          <circle cx="6.8" cy="14.1" r=".1" fill="#236" />
          <circle cx="7.5" cy="13.6" r=".1" fill="#236" />
          <circle cx="7.1" cy="13.8" r=".1" fill="#236" />
          <circle cx="6" cy="14.6" r=".1" fill="#236" />
          <rect
            x="7"
            y="11.9"
            width="1.6"
            height=".9"
            rx=".5"
            transform="rotate(-33.1 7.8 12.4)"
            fill="#f18c2d"
          />
          <rect
            x="7.3"
            y="11.8"
            width="1.5"
            height=".9"
            rx=".5"
            transform="rotate(-33.1 8 12.2)"
            fill="#f8ad3c"
          />
          <rect
            x="7.4"
            y="11.9"
            width="1.2"
            height=".6"
            rx=".3"
            transform="rotate(-33.2 8 12.2)"
            fill="#f0f9fe"
          />
          <path
            d="M7.9 12.6a.2.2 0 0 1-.3-.1.2.2 0 0 1 0-.3h.1l.2.4zM8.3 12.3a.2.2 0 0 1-.3 0 .2.2 0 0 1 0-.3h.1l.3.3z"
            fill="#c5d2eb"
          />
          <circle cx="8.3" cy="12.1" r=".2" fill="#236" />
          <circle cx="7.8" cy="12.4" r=".2" fill="#236" />
          <path
            d="M5.8 9.6c0-.1 0-.3.2-.5s.4 0 .4 0a1 1 0 0 1 0 .2l-.2.2z"
            fill="#ffc800"
          />
          <path
            d="M8.1 9.2H8v.1l-.3.2a5.3 5.3 0 0 0-1 .8 1.5 1.5 0 0 0-.5.8l-.3-.3v-.2a1.2 1.2 0 0 1-.2-.2A1.1 1.1 0 0 1 6 9.3V9l.1-.1.2-.1h.1a1 1 0 0 1 .4-.2.5.5 0 0 1 .2 0 1 1 0 0 1 .8 0l.3.5z"
            fill="#f8ad3c"
          />
          <path
            d="M8 9.3h-.2l-.4.3-.2.1s-.1-.3-.4-.4A1 1 0 0 0 6 9l.1-.1.2-.1a1.5 1.5 0 0 1 .4-.2 1.2 1.2 0 0 1 .8.2 1 1 0 0 1 .4.4z"
            fill="#fff"
            opacity=".6"
          />
          <path
            d="M7.7 8.8a1.4 1.4 0 0 0-1-.1 1.6 1.6 0 0 0-.4.2l-.1.1H6a.9.9 0 0 1 .2 0 1.1 1.1 0 0 1 .7.2c.3.2.4.4.3.5l.3-.2.5-.3c.1 0 0-.2-.3-.3z"
            fill="#f8ad3c"
          />
          <path
            d="M6.1 11.1a1.3 1.3 0 0 1 .5-.8 5.3 5.3 0 0 1 1-.8l.5-.3-.3-.4a1 1 0 0 0-.8-.1 1 1 0 0 1 .7.4l-1 .9c-.6.6-.9 1-.6 1.1z"
            fill="#f18c2d"
          />
          <path
            d="M8.5 8.9l-.4.3a.5.5 0 0 0-.1 0 2.7 2.7 0 0 0-.5.2 3 3 0 0 0-.5.4l-.4.4V10a2 2 0 0 1 .3-.4 6.1 6.1 0 0 1 .9-.7H8l.4-.2z"
            fill="#ff9600"
          />
          <path
            d="M7.8 9l.2.3a2.7 2.7 0 0 0-.5.2 3 3 0 0 0-.5.3l-.1-.1a6.1 6.1 0 0 1 .9-.7z"
            fill="#fff"
            opacity=".5"
          />
          <path
            d="M8 9c-1.1.7-1.4 1.2-1.4 1.2a7.5 7.5 0 0 1 1-.6 1.3 1.3 0 0 1 .5-.3c.2-.1.8-.8-.1-.3z"
            fill="#cc741d"
          />
          <circle cx="7.2" cy="10.4" r=".5" fill="#4184c5" />
          <circle cx="7.2" cy="10.4" r=".4" fill="#f0f9fe" />
          <circle cx="7.1" cy="10.4" r=".2" fill="#c5d2eb" />
          <circle cx="7.1" cy="10.4" r=".1" fill="#fff" />
          <path d="M7 10.5a.1.1 0 0 0 .2 0z" fill="#454f5a" />
          <circle cx="8.1" cy="9.8" r=".5" fill="#4184c5" />
          <circle cx="8.1" cy="9.8" r=".4" fill="#f0f9fe" />
          <circle cx="8.1" cy="9.8" r=".2" fill="#c5d2eb" />
          <circle cx="8.1" cy="9.8" r=".1" fill="#fff" />
          <path d="M8 10a.1.1 0 0 0 .1 0 .1.1 0 0 0 .1-.2z" fill="#454f5a" />
        </g>
        <g opacity=".5">
          <path
            d="M12.8 10a.9.9 0 0 0 0-1.3.9.9 0 0 0-1.2 0l-1.7 1.5a.9.9 0 0 0 1.2 1.3"
            fill="#53678e"
          />
          <path
            d="M12.4 10.3A.9.9 0 0 0 11.2 9l-1.7 1.5a.9.9 0 1 0 1.2 1.4"
            fill="#236"
          />
          <g clip-path="url(#badge2_h)" fill="#236">
            <path d="M11.2 9l1.3-1.2h.1l-1.3 1.3zM11.4 9.2L12.7 8l-1.2 1.3zM11.6 9.4l1.3-1.2-1.3 1.3zM11.8 9.6L13 8.4l-1.3 1.3zM12 9.8l1.3-1.2L12 10zM12.2 10l1.3-1.2-1.3 1.3zM12.4 10.2L13.7 9l-1.3 1.3z" />
          </g>
          <path
            d="M12.2 9.2H12L12 9h-.2v.1h-.2v.1h.1v.2h.1v.1H12.2v-.1h.1v-.1.3-.2-.2z"
            fill="#556289"
          />
          <rect
            x="9.6"
            y="10.2"
            width="2.8"
            height=".5"
            rx="0"
            transform="rotate(-42.4 11 10.4)"
            fill="#556289"
          />
          <circle cx="11.8" cy="9.7" r=".3" fill="#236" />
          <rect
            x="11.3"
            y="7.8"
            width="1.6"
            height=".9"
            rx=".5"
            transform="rotate(-42.4 12 8.3)"
            fill="#f18c2d"
          />
          <rect
            x="11.5"
            y="7.6"
            width="1.5"
            height=".9"
            rx=".5"
            transform="rotate(-42.4 12.2 8.1)"
            fill="#f8ad3c"
          />
          <rect
            x="11.6"
            y="7.8"
            width="1.2"
            height=".6"
            rx=".3"
            transform="rotate(-42.4 12.2 8.1)"
            fill="#f0f9fe"
          />
          <path
            d="M12.1 8.4a.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2l.3.2zM12.5 8a.2.2 0 0 1-.2-.2l.3.3z"
            fill="#c5d2eb"
          />
          <circle cx="12.4" cy="7.9" r=".2" fill="#236" />
          <circle cx="12.1" cy="8.3" r=".2" fill="#236" />
          <rect
            x="10"
            y="8.6"
            width="1.6"
            height="1.2"
            rx="0"
            transform="rotate(-42.4 10.9 9.2)"
            fill="#f0f9fe"
          />
          <circle cx="11" cy="8.5" r=".1" fill="#c5d2eb" />
          <circle cx="10.8" cy="8.8" r=".1" fill="#c5d2eb" />
          <circle cx="10.5" cy="9" r=".1" fill="#c5d2eb" />
          <circle cx="10.3" cy="9.2" r=".1" fill="#c5d2eb" />
          <circle cx="11.3" cy="8.8" r=".1" fill="#c5d2eb" />
          <circle cx="11" cy="9" r=".1" fill="#c5d2eb" />
          <circle cx="10.8" cy="9.3" r=".1" fill="#c5d2eb" />
          <circle cx="10.5" cy="9.5" r=".1" fill="#c5d2eb" />
          <circle cx="11.5" cy="9.1" r=".1" fill="#c5d2eb" />
          <circle cx="11.3" cy="9.3" r=".1" fill="#c5d2eb" />
          <circle cx="11" cy="9.5" r=".1" fill="#c5d2eb" />
          <circle cx="10.7" cy="9.8" r=".1" fill="#c5d2eb" />
          <path
            d="M10.5 10l-1.7 1.4-.5-.6a.3.3 0 0 1 0-.5l1.3-1.2z"
            fill="#c5d2eb"
          />
          <rect
            x="8.3"
            y="9.8"
            width="1.7"
            height=".8"
            rx="0"
            transform="rotate(-42.4 9.1 10.3)"
            fill="#b7c4de"
          />
          <rect
            x="8.6"
            y="10.2"
            width="1.4"
            height=".5"
            rx="0"
            transform="rotate(-42.4 9.2 10.4)"
            fill="#c5d2eb"
          />
          <rect
            x="8.5"
            y="10.3"
            width="1.4"
            height=".5"
            rx="0"
            transform="rotate(-42.4 9.2 10.5)"
            fill="#f0f9fe"
          />
          <circle cx="9.5" cy="10.2" r=".2" fill="#f8ad3c" />
          <circle cx="8.9" cy="10.8" r=".2" fill="#c5d2eb" />
          <circle cx="9.5" cy="10.2" r=".1" fill="#236" />
          <circle cx="9.2" cy="10.5" r=".1" fill="#236" />
          <circle cx="8.9" cy="10.8" r=".1" fill="#236" />
          <path
            d="M10.5 8.8l-1.8 1.6a1.6 1.6 0 0 1-.4-1.3l.5-.6a1 1 0 0 1 .2-.2l.7-.4z"
            fill="#b7c4de"
          />
          <path d="M11 8.4a1.5 1.5 0 0 0-1.3-.5l.4 1.2z" fill="#c5d2eb" />
          <path
            d="M9.8 9.4L8 11.1a1.5 1.5 0 0 1-.4-1.3l.5-.6a.8.8 0 0 1 .2-.2l.7-.5z"
            fill="#f0f9fe"
          />
          <path
            d="M10.3 9L9 8.5a1.6 1.6 0 0 0 .4 1.3zM8.8 10.3A2.2 2.2 0 0 1 8.2 9v.1a2 2 0 0 0 .5 1.3z"
            fill="#c4d9ef"
          />
          <path d="M10.4 7.7l.4-.3.3.3-.3.2-.3-.3z" fill="#7aa9d7" />
          <path d="M10.4 7.7l.3-.3.3.4-.3.2-.3-.3z" fill="#5e97ce" />
          <path
            d="M10.6 8v.1h.1l.1.4.1.2a.2.2 0 0 0 .3 0 .2.2 0 0 0 0-.3v-.2l-.2-.3a.2.2 0 0 0 0-.1l-.1-.1a.2.2 0 0 0-.3 0 .2.2 0 0 0 0 .3z"
            fill="#c5d2eb"
          />
          <path
            d="M10.5 8l.1.1.1.4.1.2a.2.2 0 0 0 .3 0 .2.2 0 0 0 0-.3v-.2H11v-.3l-.1-.2a.2.2 0 0 0-.3 0 .2.2 0 0 0 0 .3z"
            fill="#fff"
          />
          <circle cx="11" cy="8.5" r=".1" fill="#c5d2eb" />
          <path
            d="M9.5 7.2a.5.5 0 0 0 0 .7.5.5 0 0 0 .7 0l.6-.6-.7-.7z"
            fill="#5e97ce"
          />
          <path
            d="M9.4 8a.5.5 0 0 1 0-.8l.7-.6.4.4zM10.3 7.8l.3-.3.3.3-.2.2-.3-.3z"
            fill="#7aa9d7"
          />
          <path d="M10.3 7.8l.3-.3.3.4-.3.2-.3-.3z" fill="#5e97ce" />
          <circle cx="10.6" cy="7.9" r=".1" fill="#4184c5" />
          <path d="M9.6 8.5l.3-.3.3.3-.3.3-.3-.4z" fill="#7aa9d7" />
          <path d="M9.5 8.5l.3-.3.4.4-.3.2-.3-.3z" fill="#5e97ce" />
          <path
            d="M9.7 8.7l.1.1V9l.2.3.1.2a.2.2 0 0 0 .3 0 .2.2 0 0 0 0-.3V9l-.2-.4-.2-.2a.2.2 0 0 0-.3 0 .2.2 0 0 0 0 .3z"
            fill="#c5d2eb"
          />
          <path
            d="M9.7 8.8a.2.2 0 0 1 0 .2l.2.2a.2.2 0 0 0 0 .1l.1.1a.2.2 0 0 0 .3 0 .2.2 0 0 0 0-.3V9l-.1-.4-.2-.1a.2.2 0 0 0-.3 0 .2.2 0 0 0 0 .3z"
            fill="#fff"
          />
          <path
            d="M8.7 8a.5.5 0 0 0 0 .6.5.5 0 0 0 .7 0l.6-.5-.7-.7z"
            fill="#4184c5"
          />
          <path d="M8.7 8.6a.5.5 0 0 1 0-.7l.5-.5.4.3z" fill="#5e97ce" />
          <path d="M9.5 8.5l.3-.2.3.3-.3.3-.3-.4z" fill="#7aa9d7" />
          <path d="M9.4 8.6l.4-.3.3.3-.3.3-.4-.3z" fill="#5e97ce" />
          <circle cx="9.8" cy="8.7" r=".1" fill="#4184c5" />
          <rect
            x="9.7"
            y="9.2"
            width=".7"
            height=".4"
            rx="0"
            transform="rotate(-42.4 10 9.4)"
            fill="#f0f9fe"
          />
          <circle cx="10.2" cy="9.3" r=".1" fill="#c5d2eb" />
          <path d="M12.4 8.8l1-1 .4.5-1 1-.4-.5z" fill="#236" />
          <path
            d="M13.3 7.9a.1.1 0 0 1 .2 0l.3.3a.1.1 0 0 1 0 .2z"
            fill="#5e97ce"
          />
          <path
            d="M12.8 9.5a.1.1 0 0 1-.2 0l-.3-.3a.1.1 0 0 1 0-.2l.2-.1-.1-.1a.3.3 0 0 0-.5 0l-.6.5.8 1 .9-.9z"
            fill="#c5d2eb"
          />
          <path d="M11 9.6l.8-.7.8.8-.8.8-.8-.9z" fill="#f0f9fe" />
          <path
            d="M11.4 10.1l.6-.5.2.2-.6.5-.2-.2zM11.1 9.8l.6-.6.2.2-.6.6-.2-.2z"
            fill="#5e97ce"
          />
          <path d="M12 9.3l.3-.3.5.5-.3.3-.4-.5z" fill="#236" />
          <path d="M12.3 9l1-1 .4.6-1 .9-.4-.5z" fill="#7aa9d7" />
          <path
            d="M13.7 8.6a.1.1 0 0 1-.2 0l-.3-.3a.1.1 0 0 1 0-.2zM12.1 9.4l.5-.4.1.2-.4.4-.2-.2z"
            fill="#5e97ce"
          />
          <path
            d="M11.8 10.9a.9.9 0 0 0-1.2-1.3L8.9 11a.9.9 0 1 0 1.2 1.3"
            fill="#53678e"
          />
          <path
            d="M11.4 11.2a.9.9 0 1 0-1.2-1.3l-1.7 1.5a.9.9 0 1 0 1.2 1.4"
            fill="#236"
          />
          <path
            d="M10.4 10.2a.5.5 0 0 1 .7.8l-1.6 1.5a.5.5 0 1 1-.7-.8l1.6-1.5m-.1-.2l-1.7 1.6a.7.7 0 1 0 1 1l1.7-1.5a.7.7 0 0 0 0-1 .7.7 0 0 0-1 0z"
            fill="#556289"
          />
          <g clip-path="url(#badge2_i)" fill="#236">
            <path d="M10.2 10l1.3-1.3-1.2 1.3zM10.4 10.1L11.7 9l-1.2 1.3zM10.6 10.3l1.3-1.2-1.3 1.3zM10.8 10.5L12 9.3l-1.3 1.3zM11 10.7l1.3-1.2-1.3 1.3zM11.1 11l1.4-1.3-1.3 1.3zM11.4 11.2l1.3-1.2h.1l-1.3 1.3z" />
          </g>
          <g clip-path="url(#badge2_j)">
            <path
              fill="#f8623c"
              d="M10 12.2l-1-1h1v1zM10 12.3l-1-1 1 1zM10 12.4l-1.1-1.1 1 1v.1zM10 12.5l-1.2-1.2 1.1 1.1v.1z"
            />
            <path
              fill="#f8623c"
              d="M10 12.6l-1.3-1.3 1.3 1.2v.1zM10 12.7l-1.4-1.4 1.3 1.3v.1z"
            />
            <path
              fill="#f8633c"
              d="M10 12.7h-.1l-1.4-1.4 1.4 1.4zM9.9 12.8l-1.5-1.5 1.5 1.5zM8.4 11.4v-.1l1.5 1.5v.1zM8.3 11.4l1.5 1.5z"
            />
            <path fill="#f8643b" d="M8.2 11.5h.1L9.7 13zM8.2 11.5L9.8 13z" />
            <path fill="#f8653b" d="M8.1 11.6h.1L9.6 13z" />
            <path fill="#f7653b" d="M8 11.6h.1L9.6 13z" />
            <path fill="#f7663b" d="M8 11.7h.1l1.4 1.5z" />
            <path fill="#f7663a" d="M8 11.7l1.5 1.5z" />
            <path fill="#f7673a" d="M8 11.8l1.4 1.5z" />
            <path fill="#f7683a" d="M7.9 11.8l1.5 1.5z" />
            <path fill="#f7693a" d="M7.8 12v-.2l1.5 1.6z" />
            <path fill="#f76939" d="M7.8 11.9l1.5 1.5z" />
            <path fill="#f76a39" d="M7.7 12l1.5 1.5z" />
            <path fill="#f66b39" d="M7.7 12l1.5 1.4v.1z" />
            <path fill="#f66c38" d="M7.6 12.1l1.5 1.5z" />
            <path fill="#f66d38" d="M7.6 12l1.5 1.5v.1z" />
            <path fill="#f66e38" d="M7.5 12.2L9 13.6z" />
            <path fill="#f67037" d="M7.5 12.2L9 13.5l-.1.1z" />
            <path fill="#f67137" d="M7.4 12.3L9 13.7z" />
            <path fill="#f57236" d="M8.8 13.8l-1.4-1.4v-.1l1.4 1.5z" />
            <path fill="#f57336" d="M8.8 13.8v.1l-1.4-1.4v-.1l1.4 1.4z" />
            <path fill="#f57535" d="M8.7 13.9l-1.3-1.3v-.1l1.3 1.4z" />
            <path fill="#f57635" d="M8.7 14l-1.3-1.3v-.1l1.3 1.3z" />
            <path fill="#f47834" d="M8.6 14l-1.2-1.2v-.1L8.6 14z" />
            <path fill="#f47934" d="M8.6 14l-.1.1-1.1-1.2v-.1L8.6 14z" />
            <path fill="#f47b33" d="M8.5 14.1l-1.1-1v-.2l1.1 1.2z" />
            <path fill="#f47d32" d="M8.4 14.2l-1-1V13l1 1.2z" />
            <path fill="#f37e32" d="M8.3 14.2l-1-1 1 1z" />
            <path fill="#f38031" d="M8.2 14.2l-.8-.9.9.9h-.1z" />
            <path fill="#f38231" d="M8 14.2l-.6-.8.8.8H8z" />
            <path fill="#f28430" d="M8 14.2l-.6-.7.7.7H8z" />
            <path fill="#f2862f" d="M7.9 14.2l-.5-.5v-.2l.6.7h-.1z" />
            <path fill="#f2882e" d="M7.8 14.2l-.4-.4v-.2l.5.6h-.1z" />
            <path fill="#f18a2e" d="M7.7 14.2l-.3-.3v-.1l.4.4h-.1z" />
            <path fill="#f18c2d" d="M7.6 14.2l-.2-.2v-.1l.3.3h-.1z" />
            <path fill="#f18c2d" d="M7.4 14l.2.2h-.2V14z" />
          </g>
          <path
            d="M9.6 11.7h-.7v.2h-.1v.2H9v.1h.4V12h.1V12v.1h.2v-.2-.2z"
            fill="#f39336"
          />
          <circle cx="9.1" cy="12.1" r=".4" fill="#ef7844" />
          <path d="M11.3 10.1h-.5v.5h.2v.5h.2v-.4l.1-.6z" fill="#f0f9fe" />
          <circle cx="10.8" cy="10.6" r=".4" fill="#c5d2eb" />
          <rect
            x="8.6"
            y="11.1"
            width="2.8"
            height=".5"
            rx=".3"
            transform="rotate(-42.4 10 11.3)"
            fill="#f0f9fe"
          />
          <circle cx="9.1" cy="12.1" r=".2" fill="#f8ad3c" />
          <circle cx="10.8" cy="10.6" r=".2" fill="#f8ad3c" />
          <circle cx="10.8" cy="10.6" r=".1" fill="#236" />
          <circle cx="9.5" cy="11.8" r=".1" fill="#236" />
          <circle cx="9.8" cy="11.5" r=".1" fill="#236" />
          <circle cx="10.4" cy="10.9" r=".1" fill="#236" />
          <circle cx="10.1" cy="11.2" r=".1" fill="#236" />
          <circle cx="9.1" cy="12.1" r=".1" fill="#236" />
          <rect
            x="9.8"
            y="9.2"
            width="1.6"
            height=".9"
            rx=".5"
            transform="rotate(-42.4 10.6 9.6)"
            fill="#f18c2d"
          />
          <rect
            x="10"
            y="9"
            width="1.5"
            height=".9"
            rx=".5"
            transform="rotate(-42.4 10.7 9.5)"
            fill="#f8ad3c"
          />
          <rect
            x="10.1"
            y="9.2"
            width="1.2"
            height=".6"
            rx=".3"
            transform="rotate(-42.4 10.7 9.5)"
            fill="#f0f9fe"
          />
          <path
            d="M10.7 9.8a.2.2 0 1 1-.3-.3l.3.3zM11 9.4a.2.2 0 0 1-.2-.2l.2.3z"
            fill="#c5d2eb"
          />
          <circle cx="10.9" cy="9.3" r=".2" fill="#236" />
          <circle cx="10.6" cy="9.6" r=".2" fill="#236" />
          <path d="M8.1 7.2l.2-.6c.2-.3.4 0 .4 0v.2l-.2.3z" fill="#ffc800" />
          <path
            d="M10.4 6.4a.3.3 0 0 0-.2.1l-.1.1-.2.2a5.2 5.2 0 0 0-1 1 1.4 1.4 0 0 0-.2.8l-.3-.2-.2-.1A.8.8 0 0 1 8 8a1.1 1.1 0 0 1 .2-1.2l.1-.1v-.1l.2-.2h.1a1.3 1.3 0 0 1 .4-.3.5.5 0 0 1 .2 0 1 1 0 0 1 .8 0l.4.3z"
            fill="#f8ad3c"
          />
          <path
            d="M10.2 6.5a.2.2 0 0 0-.1 0l-.4.4-.2.1s-.1-.2-.4-.3a1 1 0 0 0-.8 0v-.2l.2-.1a1.5 1.5 0 0 1 .3-.2 1.2 1.2 0 0 1 1 0 .8.8 0 0 1 .4.3z"
            fill="#fff"
            opacity=".6"
          />
          <path
            d="M9.8 6.2a1.4 1.4 0 0 0-.9 0 1.6 1.6 0 0 0-.4.3 1.6 1.6 0 0 0-.2.1h.1a1.1 1.1 0 0 1 .8 0l.4.4.2-.1.5-.4-.5-.3z"
            fill="#f8ad3c"
          />
          <path
            d="M8.7 8.6a1.3 1.3 0 0 1 .3-.8 5.2 5.2 0 0 1 1-1l.4-.4s-.1-.2-.4-.3a1 1 0 0 0-.8 0 1 1 0 0 1 .8.3l-1 1c-.4.7-.6 1.2-.3 1.2z"
            fill="#f18c2d"
          />
          <path
            d="M10.7 6l-.3.5h-.2a2.8 2.8 0 0 0-.4.3 2.7 2.7 0 0 0-.4.4l-.3.4H9a1.8 1.8 0 0 1 .3-.5 5.7 5.7 0 0 1 .7-.8h.1c.4-.4.4-.3.5-.3z"
            fill="#ff9600"
          />
          <path
            d="M10 6.3l.2.2a2.8 2.8 0 0 0-.4.3 2.7 2.7 0 0 0-.4.4l-.1-.1a5.7 5.7 0 0 1 .7-.8z"
            fill="#fff"
            opacity=".5"
          />
          <path
            d="M10.2 6.3c-1 .8-1.1 1.3-1.1 1.3a6.7 6.7 0 0 1 .7-.7 1.5 1.5 0 0 1 .6-.4s.6-.8-.2-.2z"
            fill="#cc741d"
          />
          <circle cx="9.6" cy="7.8" r=".5" fill="#4184c5" />
          <circle cx="9.6" cy="7.8" r=".4" fill="#f0f9fe" />
          <circle cx="9.6" cy="7.8" r=".2" fill="#c5d2eb" />
          <circle cx="9.6" cy="7.8" r=".1" fill="#fff" />
          <path d="M9.5 8a.2.2 0 0 0 .1 0 .2.2 0 0 0 0-.2z" fill="#454f5a" />
          <circle cx="10.4" cy="7" r=".5" fill="#4184c5" />
          <circle cx="10.4" cy="7" r=".4" fill="#f0f9fe" />
          <circle cx="10.4" cy="7" r=".2" fill="#c5d2eb" />
          <circle cx="10.4" cy="7" r=".1" fill="#fff" />
          <path d="M10.4 7.2a.2.2 0 0 0 0-.2z" fill="#454f5a" />
        </g>
        <path
          d="M12.6 5c0-.1 0-.3.3-.4s.4.1.4.2a.8.8 0 0 1 0 .1l-.4.2z"
          fill="#ffc800"
        />
        <path
          d="M14.9 5.4a.3.3 0 0 0-.2 0h-.4A5.6 5.6 0 0 0 13 6a1.4 1.4 0 0 0-.7.6l-.1-.3V6a1.4 1.4 0 0 1 0-.3 1.1 1.1 0 0 1 .6-1h.6a1.5 1.5 0 0 1 .4 0 .6.6 0 0 1 .2 0 1 1 0 0 1 .7.3l.2.4z"
          fill="#f8ad3c"
        />
        <path
          d="M14.7 5.4a.2.2 0 0 0-.1 0l-.5.1h-.3l-.2-.5c-.2-.3-.5-.4-.7-.4h.4a1.5 1.5 0 0 1 .4 0 1.2 1.2 0 0 1 .7.4.8.8 0 0 1 .3.4z"
          fill="#fff"
          opacity=".6"
        />
        <path
          d="M14.5 5a1.5 1.5 0 0 0-.8-.5 1.5 1.5 0 0 0-.5 0l-.2.1h.1a1.2 1.2 0 0 1 .6.4c.2.3.3.5.2.6h.3c.4-.1.5-.2.6-.1l-.3-.6z"
          fill="#f8ad3c"
        />
        <path
          d="M12.3 6.6a1.3 1.3 0 0 1 .7-.7 5.6 5.6 0 0 1 1.3-.4h.5l-.1-.6a1 1 0 0 0-.7-.4 1 1 0 0 1 .5.7l-1.2.5c-.8.3-1.2.7-1 .9z"
          fill="#f18c2d"
        />
        <path
          d="M15.3 5.2l-.5.2h-.1a2.5 2.5 0 0 0-.5 0 4.8 4.8 0 0 0-.6.3l-.4.2v-.1a1.9 1.9 0 0 1 .4-.3 5.3 5.3 0 0 1 1-.3h.2c.4-.1.4 0 .4 0h.1z"
          fill="#ff9600"
        />
        <path
          d="M14.6 5.2v.2a2.5 2.5 0 0 0-.4 0 4.8 4.8 0 0 0-.6.3v-.2a5.3 5.3 0 0 1 1-.3z"
          fill="#fff"
          opacity=".5"
        />
        <path
          d="M14.8 5.2a3.3 3.3 0 0 0-1.6.7 7 7 0 0 1 1-.3 1.4 1.4 0 0 1 .6 0c.2-.1 1-.6 0-.4z"
          fill="#cc741d"
        />
        <path
          d="M12.3 6.5c0 .2.6.2 1 0l.5-.4a11 11 0 0 1 1-.6 2.5 2.5 0 0 0-1.3.2c-.6.2-1.2.6-1.2.8z"
          fill="#d06b33"
        />
        <path
          d="M12.6 6.5l.6-.1.4-.4.6-.4a1.8 1.8 0 0 0-1 .2c-.3.2-.7.5-.6.7z"
          fill="#d05e28"
        />
        <path
          d="M14.7 10.5a.9.9 0 1 0 0-1.8l-2.3.2a.9.9 0 0 0 0 1.7"
          fill="#53678e"
        />
        <path
          d="M14.2 10.6a.9.9 0 0 0 0-1.8h-2.3a.9.9 0 0 0 .1 1.8"
          fill="#236"
        />
        <g clip-path="url(#badge2_k)" fill="#236">
          <path d="M14.2 8.7H16l-1.8.1zM14.2 9H16l-1.8.1zM14.2 9.3H16l-1.8.1zM14.2 9.6H16l-1.8.1zM14.2 10l1.8-.1-1.8.1zM14.2 10.2H16l-1.8.1zM14.2 10.4H16l-1.8.1z" />
        </g>
        <path
          d="M14.8 9.6a.2.2 0 0 0 0-.1v-.1h-.1v-.1h-.2V9H14.1v.1a.6.6 0 0 0 0 .2v.2c0 .1 0 0 0 0v.1h.5v-.2-.1h.1v.2z"
          fill="#556289"
        />
        <rect
          x="11.7"
          y="9.5"
          width="2.8"
          height=".5"
          rx="0"
          transform="rotate(-2.6 13.1 9.6)"
          fill="#556289"
        />
        <circle cx="14.2" cy="9.7" r=".3" fill="#236" />
        <rect
          x="14.5"
          y="8.3"
          width="1.6"
          height=".9"
          rx=".5"
          transform="rotate(-2.6 15.4 8.8)"
          fill="#f18c2d"
        />
        <rect
          x="14.8"
          y="8.3"
          width="1.5"
          height=".9"
          rx=".5"
          transform="rotate(-2.6 15.6 8.8)"
          fill="#f8ad3c"
        />
        <rect
          x="14.9"
          y="8.4"
          width="1.2"
          height=".6"
          rx=".3"
          transform="rotate(-2.6 15.6 8.8)"
          fill="#f0f9fe"
        />
        <path
          d="M15.3 9a.2.2 0 0 1-.2-.2.2.2 0 0 1 .2-.2v.3zM15.8 9a.2.2 0 0 1-.2-.3.2.2 0 0 1 .1-.1h.1v.3z"
          fill="#c5d2eb"
        />
        <circle cx="15.8" cy="8.7" r=".2" fill="#236" />
        <circle cx="15.3" cy="8.8" r=".2" fill="#236" />
        <rect
          x="13"
          y="8.1"
          width="1.6"
          height="1.2"
          rx="0"
          transform="rotate(-2.6 13.8 8.8)"
          fill="#f0f9fe"
        />
        <circle cx="14.3" cy="8.3" r=".1" fill="#c5d2eb" />
        <circle cx="14" cy="8.3" r=".1" fill="#c5d2eb" />
        <circle cx="13.6" cy="8.3" r=".1" fill="#c5d2eb" />
        <circle cx="13.3" cy="8.3" r=".1" fill="#c5d2eb" />
        <circle cx="14.4" cy="8.7" r=".1" fill="#c5d2eb" />
        <circle cx="14" cy="8.7" r=".1" fill="#c5d2eb" />
        <circle cx="13.7" cy="8.7" r=".1" fill="#c5d2eb" />
        <circle cx="13.3" cy="8.7" r=".1" fill="#c5d2eb" />
        <circle cx="14.4" cy="9" r=".1" fill="#c5d2eb" />
        <circle cx="14" cy="9" r=".1" fill="#c5d2eb" />
        <circle cx="13.7" cy="9" r=".1" fill="#c5d2eb" />
        <circle cx="13.3" cy="9.1" r=".1" fill="#c5d2eb" />
        <path d="M13 9h-2.2v-.8a.3.3 0 0 1 .3-.3l1.9-.1z" fill="#c5d2eb" />
        <rect
          x="10.9"
          y="8"
          width="1.7"
          height=".8"
          rx="0"
          transform="rotate(-2.6 11.8 8.5)"
          fill="#b7c4de"
        />
        <rect
          x="11.1"
          y="8.4"
          width="1.4"
          height=".5"
          rx="0"
          transform="rotate(-2.6 11.8 8.7)"
          fill="#c5d2eb"
        />
        <rect
          x="11"
          y="8.4"
          width="1.4"
          height=".5"
          rx="0"
          transform="rotate(-2.6 11.6 8.7)"
          fill="#f0f9fe"
        />
        <circle cx="12.1" cy="8.6" r=".2" fill="#f8ad3c" />
        <circle cx="11.2" cy="8.7" r=".2" fill="#c5d2eb" />
        <circle cx="12.1" cy="8.6" r=".1" fill="#236" />
        <circle cx="11.7" cy="8.6" r=".1" fill="#236" />
        <circle cx="11.2" cy="8.7" r=".1" fill="#236" />
        <path
          d="M13.7 8.2h-2.4a1.6 1.6 0 0 1 .5-1.2l.8-.2a1 1 0 0 1 .3 0l.8.1z"
          fill="#b7c4de"
        />
        <path d="M14.4 8.1a1.6 1.6 0 0 0-.6-1.2l-.6 1.3z" fill="#c5d2eb" />
        <path
          d="M12.8 8.2l-2.4.1a1.5 1.5 0 0 1 .5-1.2l.8-.2a1 1 0 0 1 .3 0l.8.1z"
          fill="#f0f9fe"
        />
        <path
          d="M13.4 8.2L12.8 7a1.6 1.6 0 0 0-.5 1.2zM11.5 8.3a2.1 2.1 0 0 1 .4-1.4h-.1a2 2 0 0 0-.5 1.3z"
          fill="#c4d9ef"
        />
        <path d="M14.4 7.3h.4v.4h-.3v-.4z" fill="#7aa9d7" />
        <path d="M14.3 7.3h.5v.4h-.4v-.4z" fill="#5e97ce" />
        <path
          d="M14.3 7.5v.2a.2.2 0 0 1 0 .1v.5a.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2v-.5a.2.2 0 0 0 0-.1v-.2a.2.2 0 0 0-.1-.2.2.2 0 0 0-.3.3z"
          fill="#c5d2eb"
        />
        <path
          d="M14.3 7.5v.2a.3.3 0 0 1 0 .1l-.1.3v.2a.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2v-.2l.1-.3v-.3a.2.2 0 0 0-.2-.2.2.2 0 0 0-.2.3z"
          fill="#fff"
        />
        <circle cx="14.3" cy="8.3" r=".1" fill="#c5d2eb" />
        <path d="M14 6.3a.5.5 0 0 0 .1 1h.8v-1z" fill="#5e97ce" />
        <path
          d="M13.5 6.8a.5.5 0 0 1 .5-.5h.8v.5zM14.3 7.3h.4v.4h-.3v-.4h-.1z"
          fill="#7aa9d7"
        />
        <path d="M14.2 7.3h.4v.4h-.3v-.4h-.1z" fill="#5e97ce" />
        <circle cx="14.4" cy="7.5" r=".1" fill="#4184c5" />
        <path d="M13.3 7.3h.4v.5h-.3v-.5z" fill="#7aa9d7" />
        <path d="M13.2 7.3h.4v.5h-.3v-.5h-.1z" fill="#5e97ce" />
        <path
          d="M13.2 7.6v.5a.2.2 0 0 0 0 .1v.2a.2.2 0 0 0 .1.2.2.2 0 0 0 .2-.2v-.2l.1-.4v-.2a.2.2 0 0 0-.2-.2.2.2 0 0 0-.2.2z"
          fill="#c5d2eb"
        />
        <path
          d="M13.1 7.6v.5a.2.2 0 0 0 0 .1v.2a.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2v-.8a.2.2 0 0 0-.2-.2.2.2 0 0 0-.2.2z"
          fill="#fff"
        />
        <path
          d="M13 6.3a.5.5 0 0 0-.5.6.5.5 0 0 0 .5.4h.8v-1z"
          fill="#4184c5"
        />
        <path d="M12.5 6.8a.5.5 0 0 1 .4-.5h.8v.5z" fill="#5e97ce" />
        <path d="M13.1 7.3h.5v.5h-.4v-.5z" fill="#7aa9d7" />
        <path d="M13 7.3h.5v.5h-.3v-.5H13z" fill="#5e97ce" />
        <circle cx="13.3" cy="7.6" r=".1" fill="#4184c5" />
        <rect
          x="12.7"
          y="8.2"
          width=".7"
          height=".4"
          rx="0"
          transform="rotate(-2.6 13.1 8.3)"
          fill="#f0f9fe"
        />
        <circle cx="13.2" cy="8.3" r=".1" fill="#c5d2eb" />
        <path d="M15.2 9.4l1.4-.1v.7h-1.4v-.6z" fill="#236" />
        <path
          d="M16.5 9.3a.1.1 0 0 1 .2.1v.4a.1.1 0 0 1-.2.1z"
          fill="#5e97ce"
        />
        <path
          d="M15 10.2a.1.1 0 0 1 0-.2v-.3a.1.1 0 0 1 0-.2h.2v-.2A.3.3 0 0 0 15 9H14v1.2h1.2z"
          fill="#c5d2eb"
        />
        <path d="M13.6 9h1.1v1.2h-1l-.1-1.1z" fill="#f0f9fe" />
        <path
          d="M13.6 9.8h.9v.2h-.9v-.2zM13.6 9.3h.8v.3h-.8v-.3z"
          fill="#5e97ce"
        />
        <path d="M14.6 9.5h.4v.7h-.3v-.6z" fill="#236" />
        <path d="M15 9.4h1.4v.6h-1.3v-.6z" fill="#7aa9d7" />
        <path
          d="M16.3 10a.1.1 0 0 1-.1-.1v-.4a.1.1 0 0 1 .1-.1zM14.6 9.7h.6v.2h-.6v-.2z"
          fill="#5e97ce"
        />
        <path
          d="M13.4 10.6a.9.9 0 0 0 .8-1 .9.9 0 0 0-.9-.8L11 9a.9.9 0 0 0 0 1.8"
          fill="#53678e"
        />
        <path
          d="M12.9 10.6a.9.9 0 1 0 0-1.8l-2.4.1a.9.9 0 0 0 .1 1.8"
          fill="#236"
        />
        <path
          d="M12.8 9.2a.5.5 0 0 1 .6.5.5.5 0 0 1-.5.6h-2.3a.5.5 0 0 1-.6-.5.5.5 0 0 1 .5-.5l2.3-.1m0-.2h-2.3a.7.7 0 1 0 0 1.5H13a.7.7 0 1 0 0-1.5z"
          fill="#556289"
        />
        <g clip-path="url(#badge2_l)" fill="#236">
          <path d="M12.8 8.8h1.8l-1.8.1zM12.8 9.1h1.8l-1.8.1zM12.8 9.4h1.8l-1.8.1zM12.8 9.6h1.8l-1.8.1zM12.9 10l1.8-.1-1.8.1zM12.9 10.2h1.8l-1.8.1zM12.9 10.5h1.8l-1.8.1z" />
        </g>
        <g clip-path="url(#badge2_m)">
          <path fill="#f8623c" d="M11.2 10.7L11 9h.3v1.6h-.2z" />
          <path
            fill="#f8623c"
            d="M11 10.7V9l.2 1.6H11zM11 10.7V9v1.6zM11 10.7L10.7 9h.1l.1 1.6z"
          />
          <path fill="#f8623c" d="M10.9 10.7L10.8 9l.1 1.6z" />
          <path fill="#f8623c" d="M10.8 10.7L10.7 9l.2 1.6h-.1z" />
          <path fill="#f8633c" d="M10.7 10.7V9v1.6zM10.7 10.7L10.6 9l.1 1.6z" />
          <path fill="#f8633c" d="M10.6 10.7L10.5 9l.2 1.6h-.1z" />
          <path fill="#f8633c" d="M10.5 10.7L10.4 9l.2 1.6h-.1z" />
          <path fill="#f8643b" d="M10.4 10.7V9l.1 1.6zM10.3 10.7V9l.1 1.6z" />
          <path fill="#f8653b" d="M10.3 10.7L10.2 9l.2 1.6h-.1z" />
          <path fill="#f7653b" d="M10.2 10.7V9v1.6z" />
          <path fill="#f7663b" d="M10.1 10.7V9l.1 1.6z" />
          <path fill="#f7663a" d="M10 10.7V9l.1 1.6z" />
          <path fill="#f7673a" d="M10 10.7L9.9 9l.2 1.6H10z" />
          <path fill="#f7683a" d="M10 10.7L9.7 9l.2 1.6z" />
          <path fill="#f7693a" d="M9.8 10.7V9l.1 1.6z" />
          <path fill="#f76939" d="M9.8 10.7L9.7 9l.1 1.6z" />
          <path fill="#f76a39" d="M9.7 10.7L9.6 9l.2 1.6h-.1z" />
          <path fill="#f66b39" d="M9.6 10.7V9v1.6z" />
          <path fill="#f66c38" d="M9.5 10.7V9l.1 1.6z" />
          <path fill="#f66d38" d="M9.5 10.7L9.4 9l.1 1.6z" />
          <path fill="#f66e38" d="M9.4 10.7L9.3 9l.2 1.6h-.1z" />
          <path fill="#f67037" d="M9.3 10.7V9l.1 1.6z" />
          <path fill="#f67137" d="M9.3 10.7L9 9h.1l.1 1.6z" />
          <path fill="#f57236" d="M9.2 10.7L9 9l.2 1.6h-.1z" />
          <path fill="#f57336" d="M9.1 10.7V9v1.6z" />
          <path fill="#f57535" d="M9 10.7V9l.1 1.6z" />
          <path fill="#f57635" d="M9 10.7L8.9 9l.1 1.6z" />
          <path fill="#f47834" d="M8.9 10.7L8.8 9l.2 1.6h-.1z" />
          <path fill="#f47934" d="M8.8 10.7V9v1.6z" />
          <path fill="#f47b33" d="M8.7 10.7V9l.1 1.6z" />
          <path fill="#f47d32" d="M8.7 10.7L8.6 9l.1 1.6z" />
          <path fill="#f37e32" d="M8.6 10.7L8.5 9l.2 1.6h-.1z" />
          <path fill="#f38031" d="M8.5 10.7V9v1.6z" />
          <path fill="#f38231" d="M8.4 10.7V9l.1 1.6z" />
          <path fill="#f28430" d="M8.4 10.7V9v1.6z" />
          <path fill="#f2862f" d="M8.3 9.7v1-1z" />
        </g>
        <path
          d="M11.3 9.8h-.1a.6.6 0 0 1 0-.1v-.1H11v-.1h-.4v.1h-.2l.1.1v.1H10h.1a.2.2 0 0 0 0 .1V10.2h.7V10l.4-.1.2-.2z"
          fill="#f39336"
        />
        <circle cx="10.6" cy="9.8" r=".4" fill="#ef7844" />
        <path
          d="M13.5 9.7h-.1a.2.2 0 0 0 0-.1v-.2h-.1l-.3-.2V9h-.2v.1h-.2v.1h.1v.4H13.3v-.1h-.1v-.1l.3.2z"
          fill="#f0f9fe"
        />
        <circle cx="12.8" cy="9.7" r=".4" fill="#c5d2eb" />
        <rect
          x="10.3"
          y="9.5"
          width="2.8"
          height=".5"
          rx=".3"
          transform="rotate(-2.6 11.8 9.8)"
          fill="#f0f9fe"
        />
        <circle cx="10.6" cy="9.8" r=".2" fill="#f8ad3c" />
        <circle cx="12.8" cy="9.7" r=".2" fill="#f8ad3c" />
        <circle cx="12.8" cy="9.7" r=".1" fill="#236" />
        <circle cx="11.1" cy="9.8" r=".1" fill="#236" />
        <circle cx="11.5" cy="9.8" r=".1" fill="#236" />
        <circle cx="12.3" cy="9.7" r=".1" fill="#236" />
        <circle cx="11.9" cy="9.8" r=".1" fill="#236" />
        <circle cx="10.6" cy="9.8" r=".1" fill="#236" />
        <rect
          x="12.5"
          y="8.4"
          width="1.6"
          height=".9"
          rx=".5"
          transform="translate(-.4 .6)"
          fill="#f18c2d"
        />
        <rect
          x="12.8"
          y="8.4"
          width="1.5"
          height=".9"
          rx=".5"
          transform="rotate(-2.6 13.6 8.7)"
          fill="#f8ad3c"
        />
        <rect
          x="12.9"
          y="8.5"
          width="1.2"
          height=".6"
          rx=".3"
          transform="rotate(-2.6 13.6 8.7)"
          fill="#f0f9fe"
        />
        <path
          d="M13.2 9a.2.2 0 0 1-.1-.2.2.2 0 0 1 .1-.2h.1V9zM13.7 9a.2.2 0 1 1 0-.3h.1V9z"
          fill="#c5d2eb"
        />
        <circle cx="13.8" cy="8.8" r=".2" fill="#236" />
        <circle cx="13.3" cy="8.8" r=".2" fill="#236" />
        <circle cx="13.8" cy="6.8" r=".5" fill="#4184c5" />
        <circle cx="13.8" cy="6.8" r=".4" fill="#f0f9fe" />
        <circle cx="13.7" cy="6.8" r=".2" fill="#c5d2eb" />
        <circle cx="13.7" cy="6.8" r=".1" fill="#fff" />
        <circle cx="14.9" cy="6.7" r=".5" fill="#4184c5" />
        <circle cx="14.9" cy="6.7" r=".4" fill="#f0f9fe" />
        <circle cx="14.8" cy="6.8" r=".2" fill="#c5d2eb" />
        <circle cx="14.8" cy="6.8" r=".1" fill="#fff" />
        <path
          d="M14.7 6.7a.1.1 0 0 0 .1.2.1.1 0 0 0 .2-.2zM13.5 6.8a.1.1 0 0 0 .2.1.1.1 0 0 0 .1-.1z"
          fill="#454f5a"
        />
        <path
          fill="#93278f"
          d="M22.7 13.2l-7.2-1-.2 4.5-1.2-1-1.5 1.1-1.8-4.2-.2-.7-.8 1.4-6 3.9 4.7 7 3.3-2.1 1.5 2.2 9.4-11.1z"
        />
        <path
          fill="#662d91"
          d="M4.6 17.5L9 15.3l1.6.6 1 2 1.7.2.9-.8h2l1.2-4.1.9.4.5-.4 2.5 2.1-4.4 3.9-7.4 1-4.8-2.7z"
        />
      </g>
    </g>
  </svg>
);

export default Badge;



// WEBPACK FOOTER //
// ./src/components/SVG/Badge2.js